module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(10);
}, /* 1 */
, /* 2 */
, /* 3 */
, /* 4 */
, /* 5 */
, /* 6 */
, /* 7 */
, /* 8 */
, /* 9 */
, /* 10 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _Navigation = __webpack_require__(11);
    Object.defineProperty(exports, "default", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Navigation).default;
        }
    });
    var _ContainerItem = __webpack_require__(57);
    Object.defineProperty(exports, "AkContainerItem", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerItem).default;
        }
    });
    var _ContainerItemGroup = __webpack_require__(64);
    Object.defineProperty(exports, "AkContainerItemGroup", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerItemGroup).default;
        }
    });
    var _ContainerLogo = __webpack_require__(67);
    Object.defineProperty(exports, "AkContainerLogo", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerLogo).default;
        }
    });
    var _ContainerTitle = __webpack_require__(70);
    Object.defineProperty(exports, "AkContainerTitle", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerTitle).default;
        }
    });
    var _ContainerNavigation = __webpack_require__(43);
    Object.defineProperty(exports, "AkContainerNavigation", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerNavigation).default;
        }
    });
    var _ContainerNavigationNested = __webpack_require__(73);
    Object.defineProperty(exports, "AkContainerNavigationNested", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerNavigationNested).default;
        }
    });
    var _CreateDrawer = __webpack_require__(76);
    Object.defineProperty(exports, "AkCreateDrawer", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_CreateDrawer).default;
        }
    });
    var _CustomDrawer = __webpack_require__(84);
    Object.defineProperty(exports, "AkCustomDrawer", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_CustomDrawer).default;
        }
    });
    var _SearchDrawer = __webpack_require__(85);
    Object.defineProperty(exports, "AkSearchDrawer", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_SearchDrawer).default;
        }
    });
    var _DrawerItem = __webpack_require__(86);
    Object.defineProperty(exports, "AkDrawerItem", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_DrawerItem).default;
        }
    });
    var _GlobalNavigation = __webpack_require__(22);
    Object.defineProperty(exports, "AkGlobalNavigation", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_GlobalNavigation).default;
        }
    });
    var _GlobalItem = __webpack_require__(34);
    Object.defineProperty(exports, "AkGlobalItem", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_GlobalItem).default;
        }
    });
    var _Search = __webpack_require__(89);
    Object.defineProperty(exports, "AkSearch", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Search).default;
        }
    });
}, /* 11 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _Navigation = __webpack_require__(18), _Navigation2 = _interopRequireDefault(_Navigation), _GlobalNavigation = __webpack_require__(22), _GlobalNavigation2 = _interopRequireDefault(_GlobalNavigation), _ContainerNavigation = __webpack_require__(43), _ContainerNavigation2 = _interopRequireDefault(_ContainerNavigation), _DefaultLinkComponent = __webpack_require__(37), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _Resizer = __webpack_require__(50), _Resizer2 = _interopRequireDefault(_Resizer), _Spacer = __webpack_require__(28), _Spacer2 = _interopRequireDefault(_Spacer), _sharedVariables = __webpack_require__(27), _collapse = __webpack_require__(56), _collapse2 = _interopRequireDefault(_collapse), Navigation = function(_PureComponent) {
        function Navigation(props, context) {
            (0, _classCallCheck3.default)(this, Navigation);
            var _this = (0, _possibleConstructorReturn3.default)(this, (Navigation.__proto__ || (0, 
            _getPrototypeOf2.default)(Navigation)).call(this, props, context));
            return _this.onResize = function(resizeDelta) {
                _this.setState({
                    resizeDelta: resizeDelta
                });
            }, _this.getRenderedWidth = function() {
                var baselineWidth = _this.props.isOpen ? _this.props.width : _sharedVariables.containerClosedWidth, minWidth = _this.props.isCollapsible ? _sharedVariables.containerClosedWidth : _sharedVariables.navigationOpenWidth;
                return Math.max(minWidth, baselineWidth + _this.state.resizeDelta);
            }, _this.triggerResizeHandler = function() {
                var width = _this.getRenderedWidth(), snappedWidth = function() {
                    return width > _sharedVariables.navigationOpenWidth ? width : width < _sharedVariables.resizeClosedBreakpoint ? _sharedVariables.containerClosedWidth : _sharedVariables.navigationOpenWidth;
                }(), resizeState = {
                    isOpen: width >= _sharedVariables.resizeClosedBreakpoint,
                    width: snappedWidth
                };
                _this.setState({
                    resizeDelta: 0
                }, function() {
                    this.props.onResize(resizeState);
                });
            }, _this.triggerResizeButtonHandler = function(resizeState) {
                _this.props.onResize(resizeState);
            }, _this.state = {
                resizeDelta: 0
            }, _this;
        }
        return (0, _inherits3.default)(Navigation, _PureComponent), (0, _createClass3.default)(Navigation, [ {
            key: "isCollapsed",
            value: function() {
                var _props = this.props, isCollapsible = _props.isCollapsible, isOpen = _props.isOpen;
                return !!isCollapsible && (!isOpen && this.state.resizeDelta <= 0);
            }
        }, {
            key: "render",
            value: function() {
                var _props2 = this.props, children = _props2.children, containerAppearance = _props2.containerAppearance, containerHeaderComponent = _props2.containerHeaderComponent, drawers = _props2.drawers, globalAppearance = _props2.globalAppearance, globalCreateIcon = _props2.globalCreateIcon, globalPrimaryIcon = _props2.globalPrimaryIcon, globalPrimaryItemHref = _props2.globalPrimaryItemHref, globalSearchIcon = _props2.globalSearchIcon, globalSecondaryActions = _props2.globalSecondaryActions, isResizeable = _props2.isResizeable, linkComponent = _props2.linkComponent, onCreateDrawerOpen = _props2.onCreateDrawerOpen, onResizeStart = _props2.onResizeStart, onSearchDrawerOpen = _props2.onSearchDrawerOpen, shouldAnimate = 0 === this.state.resizeDelta, renderedWidth = this.getRenderedWidth(), isPartiallyCollapsed = renderedWidth < _sharedVariables.globalOpenWidth + _sharedVariables.containerClosedWidth;
                return _react2.default.createElement("div", {
                    className: _Navigation2.default.navigation
                }, _react2.default.createElement(_Spacer2.default, {
                    shouldAnimate: shouldAnimate,
                    width: renderedWidth
                }), _react2.default.createElement("div", {
                    className: _Navigation2.default.navigationInner
                }, _react2.default.createElement("div", {
                    style: {
                        zIndex: !isPartiallyCollapsed && 1
                    }
                }, _react2.default.createElement(_GlobalNavigation2.default, {
                    appearance: globalAppearance,
                    createIcon: globalCreateIcon,
                    linkComponent: linkComponent,
                    onCreateActivate: onCreateDrawerOpen,
                    onSearchActivate: onSearchDrawerOpen,
                    primaryIcon: globalPrimaryIcon,
                    primaryItemHref: globalPrimaryItemHref,
                    searchIcon: globalSearchIcon,
                    shouldAnimate: shouldAnimate,
                    secondaryActions: globalSecondaryActions
                })), _react2.default.createElement("div", {
                    style: {
                        zIndex: 2,
                        position: "relative"
                    }
                }, drawers), _react2.default.createElement("div", null, _react2.default.createElement(_ContainerNavigation2.default, {
                    appearance: containerAppearance,
                    areGlobalActionsVisible: this.isCollapsed(),
                    globalCreateIcon: globalCreateIcon,
                    globalPrimaryIcon: globalPrimaryIcon,
                    globalPrimaryItemHref: globalPrimaryItemHref,
                    globalSearchIcon: globalSearchIcon,
                    headerComponent: containerHeaderComponent,
                    linkComponent: linkComponent,
                    offsetX: Math.min(renderedWidth - (_sharedVariables.globalOpenWidth + _sharedVariables.containerClosedWidth), 0),
                    onGlobalCreateActivate: onCreateDrawerOpen,
                    onGlobalSearchActivate: onSearchDrawerOpen,
                    shouldAnimate: shouldAnimate,
                    width: (0, _collapse2.default)(renderedWidth)
                }, children)), isResizeable ? _react2.default.createElement(_Resizer2.default, {
                    navigationWidth: renderedWidth,
                    onResize: this.onResize,
                    onResizeButton: this.triggerResizeButtonHandler,
                    onResizeStart: onResizeStart,
                    onResizeEnd: this.triggerResizeHandler
                }) : null));
            }
        } ]), Navigation;
    }(_react.PureComponent);
    Navigation.propTypes = {
        children: _react.PropTypes.node,
        containerAppearance: _react.PropTypes.string,
        containerHeaderComponent: _react.PropTypes.func,
        drawers: _react.PropTypes.arrayOf(_react.PropTypes.node),
        globalAppearance: _react.PropTypes.string,
        globalCreateIcon: _react.PropTypes.node,
        globalPrimaryIcon: _react.PropTypes.node,
        globalPrimaryItemHref: _react.PropTypes.string,
        globalSearchIcon: _react.PropTypes.node,
        globalSecondaryActions: _react.PropTypes.arrayOf(_react.PropTypes.node),
        isCollapsible: _react.PropTypes.bool,
        isOpen: _react.PropTypes.bool,
        isResizeable: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onCreateDrawerOpen: _react.PropTypes.func,
        onResize: _react.PropTypes.func,
        onResizeStart: _react.PropTypes.func,
        onSearchDrawerOpen: _react.PropTypes.func,
        width: _react.PropTypes.number
    }, Navigation.defaultProps = {
        containerAppearance: "container",
        drawers: [],
        globalAppearance: "global",
        globalSecondaryActions: [],
        isCollapsible: !0,
        isCreateDrawerOpen: !1,
        isOpen: !0,
        isResizeable: !0,
        isSearchDrawerOpen: !1,
        linkComponent: _DefaultLinkComponent2.default,
        onCreateDrawerOpen: function() {},
        onResize: function() {},
        onResizeStart: function() {},
        onSearchDrawerOpen: function() {},
        width: _sharedVariables.navigationOpenWidth
    }, exports.default = Navigation;
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 16 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 17 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 18 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(19);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 19 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._3CbQLAml_7L7dZeVXmgvKV{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;z-index:2;-webkit-box-flex:1;flex:1 0 auto}._1luNJb_WEWRZWOuSAEVG5V{height:100%;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;position:fixed;left:0;z-index:300}", "" ]), 
    // exports
    exports.locals = {
        navigation: "_3CbQLAml_7L7dZeVXmgvKV",
        navigation: "_3CbQLAml_7L7dZeVXmgvKV",
        navigationInner: "_1luNJb_WEWRZWOuSAEVG5V",
        navigationInner: "_1luNJb_WEWRZWOuSAEVG5V"
    };
}, /* 20 */
/***/
function(module, exports) {
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    // css base code, injected by the css-loader
    module.exports = function() {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            for (var result = [], i = 0; i < this.length; i++) {
                var item = this[i];
                item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
            }
            return result.join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 21 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, styleElement) {
        var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
        styleElementsInsertedAtTop.push(styleElement); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            head.appendChild(styleElement);
        }
    }
    function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var styleElement = document.createElement("style");
        return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
        styleElement;
    }
    function createLinkElement(options) {
        var linkElement = document.createElement("link");
        return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
        linkElement;
    }
    function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
        update = updateLink.bind(null, styleElement), remove = function() {
            removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
        }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
        remove = function() {
            removeStyleElement(styleElement);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
            childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
        }
    }
    function applyToTag(styleElement, obj) {
        var css = obj.css, media = obj.media;
        if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
            for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
            styleElement.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(linkElement, obj) {
        var css = obj.css, sourceMap = obj.sourceMap;
        sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    var stylesInDom = {}, memoize = function(fn) {
        var memo;
        return function() {
            return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
        };
    }, isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
    }), getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName("head")[0];
    }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
    module.exports = function(list, options) {
        options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
        "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
        var styles = listToStyles(list);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                var newStyles = listToStyles(newList);
                addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
}, /* 22 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _GlobalNavigation = __webpack_require__(25), _GlobalNavigation2 = _interopRequireDefault(_GlobalNavigation), _sharedVariables = __webpack_require__(27), _Spacer = __webpack_require__(28), _Spacer2 = _interopRequireDefault(_Spacer), _GlobalPrimaryActions = __webpack_require__(31), _GlobalPrimaryActions2 = _interopRequireDefault(_GlobalPrimaryActions), _GlobalSecondaryActions = __webpack_require__(41), _GlobalSecondaryActions2 = _interopRequireDefault(_GlobalSecondaryActions), _DefaultLinkComponent = __webpack_require__(37), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), GlobalNavigation = function(_PureComponent) {
        function GlobalNavigation() {
            return (0, _classCallCheck3.default)(this, GlobalNavigation), (0, _possibleConstructorReturn3.default)(this, (GlobalNavigation.__proto__ || (0, 
            _getPrototypeOf2.default)(GlobalNavigation)).apply(this, arguments));
        }
        return (0, _inherits3.default)(GlobalNavigation, _PureComponent), (0, _createClass3.default)(GlobalNavigation, [ {
            key: "render",
            value: function() {
                var _classNames, _props = this.props, appearance = _props.appearance, createIcon = _props.createIcon, linkComponent = _props.linkComponent, onCreateActivate = _props.onCreateActivate, onSearchActivate = _props.onSearchActivate, primaryIcon = _props.primaryIcon, primaryItemHref = _props.primaryItemHref, searchIcon = _props.searchIcon, shouldAnimate = _props.shouldAnimate, secondaryActions = _props.secondaryActions;
                return _react2.default.createElement("nav", {
                    className: (0, _classnames2.default)(_GlobalNavigation2.default.globalNavigationOuter, (_classNames = {}, 
                    (0, _defineProperty3.default)(_classNames, _GlobalNavigation2.default.shouldAnimate, shouldAnimate), 
                    (0, _defineProperty3.default)(_classNames, _GlobalNavigation2.default.hasSettingsAppearance, "settings" === appearance), 
                    (0, _defineProperty3.default)(_classNames, _GlobalNavigation2.default.test, !0), 
                    _classNames))
                }, _react2.default.createElement(_Spacer2.default, {
                    shouldAnimate: shouldAnimate,
                    width: _sharedVariables.globalOpenWidth
                }), _react2.default.createElement("div", {
                    className: _GlobalNavigation2.default.globalNavigation
                }, _react2.default.createElement("div", {
                    className: _GlobalNavigation2.default.primaryContainer
                }, _react2.default.createElement(_GlobalPrimaryActions2.default, {
                    appearance: appearance,
                    createIcon: createIcon,
                    linkComponent: linkComponent,
                    onCreateActivate: onCreateActivate,
                    onSearchActivate: onSearchActivate,
                    primaryIcon: primaryIcon,
                    primaryItemHref: primaryItemHref,
                    searchIcon: searchIcon
                })), _react2.default.createElement("div", {
                    className: _GlobalNavigation2.default.secondaryContainer
                }, secondaryActions.length ? _react2.default.createElement(_GlobalSecondaryActions2.default, {
                    actions: secondaryActions
                }) : null)));
            }
        } ]), GlobalNavigation;
    }(_react.PureComponent);
    GlobalNavigation.propTypes = {
        appearance: _react.PropTypes.string,
        linkComponent: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node,
        primaryItemHref: _react.PropTypes.string,
        shouldAnimate: _react.PropTypes.bool,
        searchIcon: _react.PropTypes.node,
        onSearchActivate: _react.PropTypes.func,
        onCreateActivate: _react.PropTypes.func,
        createIcon: _react.PropTypes.node,
        secondaryActions: _react.PropTypes.arrayOf(_react.PropTypes.node)
    }, GlobalNavigation.defaultProps = {
        accountItem: null,
        helpItem: null,
        linkComponent: _DefaultLinkComponent2.default,
        primaryIcon: null,
        shouldAnimate: !1,
        secondaryActions: []
    }, exports.default = GlobalNavigation;
}, /* 23 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 24 */
/***/
function(module, exports) {
    module.exports = require("classnames");
}, /* 25 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(26);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 26 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._3RFv70CxiDSpBwue7mioPt{position:relative}._2eSSQIS7ouE1ILjauPj_Yw{-webkit-box-align:center;align-items:center;background:#0049b0;box-sizing:border-box;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;height:100%;padding-bottom:0;padding:24px 0 16px;position:fixed;width:64px}._35D2Nzz0GQxBqRkRXhLgqt ._2eSSQIS7ouE1ILjauPj_Yw{-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}._1s-iJX4Bf4-MOZriBuTha- ._2eSSQIS7ouE1ILjauPj_Yw{background:#172b4d}._2QN9ieKDOKK4huAtJwqNzL{margin-bottom:12px;margin-top:4px}._3zo8rthFT_AtbMXATEEGEo{-webkit-box-flex:1;flex:1}._1G0dCpiR8wKv09-Av5pOmD{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center;padding-bottom:20px}", "" ]), 
    // exports
    exports.locals = {
        globalNavigationOuter: "_3RFv70CxiDSpBwue7mioPt",
        globalNavigationOuter: "_3RFv70CxiDSpBwue7mioPt",
        globalNavigation: "_2eSSQIS7ouE1ILjauPj_Yw",
        globalNavigation: "_2eSSQIS7ouE1ILjauPj_Yw",
        shouldAnimate: "_35D2Nzz0GQxBqRkRXhLgqt",
        shouldAnimate: "_35D2Nzz0GQxBqRkRXhLgqt",
        hasSettingsAppearance: "_1s-iJX4Bf4-MOZriBuTha-",
        hasSettingsAppearance: "_1s-iJX4Bf4-MOZriBuTha-",
        primaryItem: "_2QN9ieKDOKK4huAtJwqNzL",
        primaryItem: "_2QN9ieKDOKK4huAtJwqNzL",
        primaryContainer: "_3zo8rthFT_AtbMXATEEGEo",
        primaryContainer: "_3zo8rthFT_AtbMXATEEGEo",
        secondaryContainer: "_1G0dCpiR8wKv09-Av5pOmD",
        secondaryContainer: "_1G0dCpiR8wKv09-Av5pOmD"
    };
}, /* 27 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    /**
	 * NOTE: these variables are duplicated in shared-variables.less
	 * NOTE: changing the width of the Navigation is considered a breaking change
	 */
    var globalOpenWidth = exports.globalOpenWidth = 64, containerOpenWidth = exports.containerOpenWidth = 240, containerClosedWidth = exports.containerClosedWidth = 64;
    exports.navigationOpenWidth = globalOpenWidth + containerOpenWidth, exports.resizeClosedBreakpoint = globalOpenWidth + containerOpenWidth / 2, 
    exports.collapseBreakpoint = globalOpenWidth + containerClosedWidth, exports.containerNavigationNestedPageSpacing = 8, 
    exports.searchIconOffset = 80, exports.createIconOffset = 120;
}, /* 28 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _Spacer = __webpack_require__(29), _Spacer2 = _interopRequireDefault(_Spacer), Spacer = function(_PureComponent) {
        function Spacer() {
            return (0, _classCallCheck3.default)(this, Spacer), (0, _possibleConstructorReturn3.default)(this, (Spacer.__proto__ || (0, 
            _getPrototypeOf2.default)(Spacer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Spacer, _PureComponent), (0, _createClass3.default)(Spacer, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Spacer2.default.spacer, (0, _defineProperty3.default)({}, _Spacer2.default.shouldAnimate, this.props.shouldAnimate)),
                    style: {
                        width: this.props.width
                    }
                });
            }
        } ]), Spacer;
    }(_react.PureComponent);
    Spacer.propTypes = {
        width: _react.PropTypes.number,
        shouldAnimate: _react.PropTypes.bool
    }, Spacer.defaultProps = {
        width: 0,
        shouldAnimate: !1
    }, exports.default = Spacer;
}, /* 29 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(30);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 30 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._1Hgak6qT_zLj2s8XutVXVF._2ABJJ7hULI5Gk0nAUNge7H{-webkit-transition:width .2s;transition:width .2s}", "" ]), 
    // exports
    exports.locals = {
        spacer: "_1Hgak6qT_zLj2s8XutVXVF",
        spacer: "_1Hgak6qT_zLj2s8XutVXVF",
        shouldAnimate: "_2ABJJ7hULI5Gk0nAUNge7H",
        shouldAnimate: "_2ABJJ7hULI5Gk0nAUNge7H"
    };
}, /* 31 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _GlobalPrimaryActions = __webpack_require__(32), _GlobalPrimaryActions2 = _interopRequireDefault(_GlobalPrimaryActions), _GlobalItem = __webpack_require__(34), _GlobalItem2 = _interopRequireDefault(_GlobalItem), _DrawerTrigger = __webpack_require__(38), _DrawerTrigger2 = _interopRequireDefault(_DrawerTrigger), _DefaultLinkComponent = __webpack_require__(37), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), GlobalPrimaryActions = function(_PureComponent) {
        function GlobalPrimaryActions() {
            return (0, _classCallCheck3.default)(this, GlobalPrimaryActions), (0, _possibleConstructorReturn3.default)(this, (GlobalPrimaryActions.__proto__ || (0, 
            _getPrototypeOf2.default)(GlobalPrimaryActions)).apply(this, arguments));
        }
        return (0, _inherits3.default)(GlobalPrimaryActions, _PureComponent), (0, _createClass3.default)(GlobalPrimaryActions, [ {
            key: "render",
            value: function() {
                var _props = this.props, appearance = _props.appearance, createIcon = _props.createIcon, isVisible = _props.isVisible, linkComponent = _props.linkComponent, onCreateActivate = _props.onCreateActivate, onSearchActivate = _props.onSearchActivate, primaryIcon = _props.primaryIcon, primaryItemHref = _props.primaryItemHref, searchIcon = _props.searchIcon;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_GlobalPrimaryActions2.default.globalActions, (0, 
                    _defineProperty3.default)({}, _GlobalPrimaryActions2.default.isVisible, isVisible))
                }, primaryIcon ? _react2.default.createElement("div", {
                    className: _GlobalPrimaryActions2.default.primaryItem
                }, _react2.default.createElement(_GlobalItem2.default, {
                    appearance: appearance,
                    href: primaryItemHref,
                    linkComponent: linkComponent,
                    size: "medium"
                }, primaryIcon)) : null, _react2.default.createElement("div", {
                    className: _GlobalPrimaryActions2.default.actions
                }, searchIcon ? _react2.default.createElement(_DrawerTrigger2.default, {
                    onActivate: onSearchActivate
                }, _react2.default.createElement(_GlobalItem2.default, {
                    appearance: appearance,
                    size: "medium"
                }, searchIcon)) : null, createIcon ? _react2.default.createElement(_DrawerTrigger2.default, {
                    onActivate: onCreateActivate
                }, _react2.default.createElement(_GlobalItem2.default, {
                    appearance: appearance,
                    size: "medium"
                }, createIcon)) : null));
            }
        } ]), GlobalPrimaryActions;
    }(_react.PureComponent);
    GlobalPrimaryActions.propTypes = {
        appearance: _react.PropTypes.string,
        createIcon: _react.PropTypes.node,
        isVisible: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onCreateActivate: _react.PropTypes.func,
        onSearchActivate: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node,
        primaryItemHref: _react.PropTypes.string,
        searchIcon: _react.PropTypes.node
    }, GlobalPrimaryActions.defaultProps = {
        isVisible: !0,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = GlobalPrimaryActions;
}, /* 32 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(33);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 33 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._282HmtfXTTiaRdnHc8qjlE{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;margin-top:16px}.Cz4OtoqIomhri5qL407Jz{box-sizing:border-box;height:0;opacity:0;visibility:hidden;-webkit-transition:height .22s,margin .22s,opacity .22s;transition:height .22s,margin .22s,opacity .22s}.Cz4OtoqIomhri5qL407Jz ._1mzqC_M03JACPQoV8F9wTF{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.Cz4OtoqIomhri5qL407Jz._3tF5nj76N0pOOsTrzwL6hM{height:136px;margin-bottom:28px;opacity:1;visibility:visible}", "" ]), 
    // exports
    exports.locals = {
        actions: "_282HmtfXTTiaRdnHc8qjlE",
        actions: "_282HmtfXTTiaRdnHc8qjlE",
        globalActions: "Cz4OtoqIomhri5qL407Jz",
        globalActions: "Cz4OtoqIomhri5qL407Jz",
        primaryItem: "_1mzqC_M03JACPQoV8F9wTF",
        primaryItem: "_1mzqC_M03JACPQoV8F9wTF",
        isVisible: "_3tF5nj76N0pOOsTrzwL6hM",
        isVisible: "_3tF5nj76N0pOOsTrzwL6hM"
    };
}, /* 34 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _GlobalItem = __webpack_require__(35), _GlobalItem2 = _interopRequireDefault(_GlobalItem), _DefaultLinkComponent = __webpack_require__(37), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), GlobalItem = function(_PureComponent) {
        function GlobalItem() {
            return (0, _classCallCheck3.default)(this, GlobalItem), (0, _possibleConstructorReturn3.default)(this, (GlobalItem.__proto__ || (0, 
            _getPrototypeOf2.default)(GlobalItem)).apply(this, arguments));
        }
        return (0, _inherits3.default)(GlobalItem, _PureComponent), (0, _createClass3.default)(GlobalItem, [ {
            key: "render",
            value: function() {
                var _classNames, _props = this.props, href = _props.href, Link = _props.linkComponent;
                return _react2.default.createElement(Link, {
                    href: href
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_GlobalItem2.default.globalItem, (_classNames = {}, 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.smallGlobalItem, "small" === this.props.size), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.mediumGlobalItem, "medium" === this.props.size), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.largeGlobalItem, "large" === this.props.size), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.isSelected, this.props.isSelected), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.hasContainerAppearance, "container" === this.props.appearance), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.hasSettingsAppearance, "settings" === this.props.appearance), 
                    _classNames))
                }, this.props.children));
            }
        } ]), GlobalItem;
    }(_react.PureComponent);
    GlobalItem.propTypes = {
        appearance: _react.PropTypes.oneOf([ "container", "global", "settings" ]),
        children: _react.PropTypes.node,
        href: _react.PropTypes.string,
        isSelected: _react.PropTypes.bool,
        size: _react.PropTypes.oneOf([ "small", "medium", "large" ]),
        linkComponent: _react.PropTypes.func
    }, GlobalItem.defaultProps = {
        appearance: "global",
        size: "small",
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = GlobalItem;
}, /* 35 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(36);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 36 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._1YwZ4yrPOqQLiNBSRRFA0A{-webkit-box-align:center;align-items:center;border-radius:50%;color:#fff;cursor:pointer;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}._1YwZ4yrPOqQLiNBSRRFA0A._1DTVHWp1htWVnfG6a6FMC8,._1YwZ4yrPOqQLiNBSRRFA0A:focus,._1YwZ4yrPOqQLiNBSRRFA0A:hover{background-color:rgba(9,30,66,.48)}._1YwZ4yrPOqQLiNBSRRFA0A:active{background-color:#2684ff}._3IaaRVJlU7LXAUpriXAb1N{height:32px;margin-top:8px;width:32px}._6oaMhhGGzwouwp0RFY657{height:40px;width:40px}._2ZDg_7bwOBaj2SYoHLznPc{height:48px;width:48px}.hwagAP_DnacBqzA39SHMW{color:#42526e}.hwagAP_DnacBqzA39SHMW:hover{background-color:rgba(9,30,66,.04)}.hwagAP_DnacBqzA39SHMW:active{color:#0049b0;background-color:#deebff}._12YUPAkBPZ9yCXt3pCMQZK{color:#fff}._12YUPAkBPZ9yCXt3pCMQZK:hover{background-color:#091e42}._12YUPAkBPZ9yCXt3pCMQZK:active{color:#ebecf0;background-color:#42526e}", "" ]), 
    // exports
    exports.locals = {
        globalItem: "_1YwZ4yrPOqQLiNBSRRFA0A",
        globalItem: "_1YwZ4yrPOqQLiNBSRRFA0A",
        isSelected: "_1DTVHWp1htWVnfG6a6FMC8",
        isSelected: "_1DTVHWp1htWVnfG6a6FMC8",
        smallGlobalItem: "_3IaaRVJlU7LXAUpriXAb1N",
        smallGlobalItem: "_3IaaRVJlU7LXAUpriXAb1N",
        mediumGlobalItem: "_6oaMhhGGzwouwp0RFY657",
        mediumGlobalItem: "_6oaMhhGGzwouwp0RFY657",
        largeGlobalItem: "_2ZDg_7bwOBaj2SYoHLznPc",
        largeGlobalItem: "_2ZDg_7bwOBaj2SYoHLznPc",
        hasContainerAppearance: "hwagAP_DnacBqzA39SHMW",
        hasContainerAppearance: "hwagAP_DnacBqzA39SHMW",
        hasSettingsAppearance: "_12YUPAkBPZ9yCXt3pCMQZK",
        hasSettingsAppearance: "_12YUPAkBPZ9yCXt3pCMQZK"
    };
}, /* 37 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), DefaultLinkComponent = function(_PureComponent) {
        function DefaultLinkComponent() {
            return (0, _classCallCheck3.default)(this, DefaultLinkComponent), (0, _possibleConstructorReturn3.default)(this, (DefaultLinkComponent.__proto__ || (0, 
            _getPrototypeOf2.default)(DefaultLinkComponent)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DefaultLinkComponent, _PureComponent), (0, _createClass3.default)(DefaultLinkComponent, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, className = _props.className, href = _props.href, onClick = _props.onClick, onMouseDown = _props.onMouseDown;
                return href ? _react2.default.createElement("a", {
                    className: className,
                    href: href,
                    onClick: onClick,
                    onMouseDown: onMouseDown
                }, children) : children;
            }
        } ]), DefaultLinkComponent;
    }(_react.PureComponent);
    DefaultLinkComponent.propTypes = {
        children: _react.PropTypes.node,
        className: _react.PropTypes.string,
        href: _react.PropTypes.string,
        onClick: _react.PropTypes.func,
        onMouseDown: _react.PropTypes.func
    }, exports.default = DefaultLinkComponent;
}, /* 38 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _DrawerTrigger = __webpack_require__(39), _DrawerTrigger2 = _interopRequireDefault(_DrawerTrigger), DrawerTrigger = function(_PureComponent) {
        function DrawerTrigger() {
            return (0, _classCallCheck3.default)(this, DrawerTrigger), (0, _possibleConstructorReturn3.default)(this, (DrawerTrigger.__proto__ || (0, 
            _getPrototypeOf2.default)(DrawerTrigger)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DrawerTrigger, _PureComponent), (0, _createClass3.default)(DrawerTrigger, [ {
            key: "render",
            value: function() {
                return null === this.props.children ? null : _react2.default.createElement("button", {
                    "aria-haspopup": "true",
                    className: _DrawerTrigger2.default.drawerTrigger,
                    onClick: this.props.onActivate,
                    onMouseDown: function(e) {
                        return e.preventDefault();
                    }
                }, this.props.children);
            }
        } ]), DrawerTrigger;
    }(_react.PureComponent);
    DrawerTrigger.propTypes = {
        children: _react.PropTypes.node,
        onActivate: _react.PropTypes.func
    }, DrawerTrigger.defaultProps = {
        onActivate: function() {}
    }, exports.default = DrawerTrigger;
}, /* 39 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(40);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 40 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, ".ZUyhrU69U5pnJd-fNfhQK{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;margin:0;background:none;border:none;border-radius:50%;padding:0;width:40px;height:40px;outline:none;color:#fff}.ZUyhrU69U5pnJd-fNfhQK:focus{outline:none;box-shadow:0 0 0 2px #4c9aff}", "" ]), 
    // exports
    exports.locals = {
        drawerTrigger: "ZUyhrU69U5pnJd-fNfhQK",
        drawerTrigger: "ZUyhrU69U5pnJd-fNfhQK"
    };
}, /* 41 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _invariant = __webpack_require__(42), _invariant2 = _interopRequireDefault(_invariant), maxSecondaryItems = 4, checkIfTooManySecondaryActions = function() {
        var actions = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        return (0, _invariant2.default)(actions.length <= maxSecondaryItems, "cannot have more than " + maxSecondaryItems + " secondary actions");
    }, GlobalSecondaryActions = function(_PureComponent) {
        function GlobalSecondaryActions(props, context) {
            (0, _classCallCheck3.default)(this, GlobalSecondaryActions);
            var _this = (0, _possibleConstructorReturn3.default)(this, (GlobalSecondaryActions.__proto__ || (0, 
            _getPrototypeOf2.default)(GlobalSecondaryActions)).call(this, props, context));
            return checkIfTooManySecondaryActions(props.actions), _this;
        }
        return (0, _inherits3.default)(GlobalSecondaryActions, _PureComponent), (0, _createClass3.default)(GlobalSecondaryActions, [ {
            key: "componentWillReceiveProps",
            value: function(nextProps) {
                checkIfTooManySecondaryActions(nextProps.actions);
            }
        }, {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", null, this.props.actions.map(function(action, index) {
                    return _react2.default.createElement("div", {
                        key: index
                    }, action);
                }));
            }
        } ]), GlobalSecondaryActions;
    }(_react.PureComponent);
    GlobalSecondaryActions.propTypes = {
        actions: _react.PropTypes.arrayOf(_react.PropTypes.node).isRequired
    }, exports.default = GlobalSecondaryActions;
}, /* 42 */
/***/
function(module, exports) {
    module.exports = require("invariant");
}, /* 43 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _ContainerNavigation = __webpack_require__(44), _ContainerNavigation2 = _interopRequireDefault(_ContainerNavigation), _ContainerHeader = __webpack_require__(46), _ContainerHeader2 = _interopRequireDefault(_ContainerHeader), _DefaultLinkComponent = __webpack_require__(37), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _GlobalPrimaryActions = __webpack_require__(31), _GlobalPrimaryActions2 = _interopRequireDefault(_GlobalPrimaryActions), _sharedVariables = __webpack_require__(27), _Spacer = __webpack_require__(28), _Spacer2 = _interopRequireDefault(_Spacer), ContainerNavigation = function(_PureComponent) {
        function ContainerNavigation() {
            return (0, _classCallCheck3.default)(this, ContainerNavigation), (0, _possibleConstructorReturn3.default)(this, (ContainerNavigation.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerNavigation)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerNavigation, _PureComponent), (0, _createClass3.default)(ContainerNavigation, [ {
            key: "getOuterStyles",
            value: function() {
                return this.props.offsetX ? {
                    marginLeft: this.props.offsetX + "px",
                    width: this.props.width
                } : {
                    width: this.props.width
                };
            }
        }, {
            key: "render",
            value: function() {
                var _classNames2, _props = this.props, appearance = _props.appearance, areGlobalActionsVisible = _props.areGlobalActionsVisible, children = _props.children, globalCreateIcon = _props.globalCreateIcon, globalPrimaryIcon = _props.globalPrimaryIcon, globalPrimaryItemHref = _props.globalPrimaryItemHref, globalSearchIcon = _props.globalSearchIcon, headerComponent = _props.headerComponent, linkComponent = _props.linkComponent, offsetX = _props.offsetX, onGlobalCreateActivate = _props.onGlobalCreateActivate, onGlobalSearchActivate = _props.onGlobalSearchActivate, shouldAnimate = _props.shouldAnimate, width = _props.width, isWidthCollapsed = width <= _sharedVariables.containerClosedWidth;
                return _react2.default.createElement("nav", {
                    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _ContainerNavigation2.default.shouldAnimate, shouldAnimate)),
                    "data-__ak-navigation-container-closed": isWidthCollapsed
                }, _react2.default.createElement(_Spacer2.default, {
                    shouldAnimate: shouldAnimate,
                    width: width + offsetX
                }), _react2.default.createElement("div", {
                    className: _ContainerNavigation2.default.containerNavigationOuter,
                    style: this.getOuterStyles()
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_ContainerNavigation2.default.containerNavigationInner, (_classNames2 = {}, 
                    (0, _defineProperty3.default)(_classNames2, _ContainerNavigation2.default.hasContainerHeader, null !== headerComponent), 
                    (0, _defineProperty3.default)(_classNames2, _ContainerNavigation2.default.hasGlobalAppearance, "global" === appearance), 
                    (0, _defineProperty3.default)(_classNames2, _ContainerNavigation2.default.hasSettingsAppearance, "settings" === appearance), 
                    _classNames2))
                }, _react2.default.createElement(_GlobalPrimaryActions2.default, {
                    appearance: appearance,
                    createIcon: globalCreateIcon,
                    isVisible: areGlobalActionsVisible,
                    linkComponent: linkComponent,
                    onCreateActivate: onGlobalCreateActivate,
                    onSearchActivate: onGlobalSearchActivate,
                    primaryIcon: globalPrimaryIcon,
                    primaryItemHref: globalPrimaryItemHref,
                    searchIcon: globalSearchIcon
                }), _react2.default.createElement("div", null, this.props.headerComponent ? _react2.default.createElement(_ContainerHeader2.default, null, this.props.headerComponent({
                    isCollapsed: width <= _sharedVariables.containerClosedWidth
                })) : null), _react2.default.createElement("div", null, children))));
            }
        } ]), ContainerNavigation;
    }(_react.PureComponent);
    ContainerNavigation.propTypes = {
        appearance: _react.PropTypes.string,
        areGlobalActionsVisible: _react.PropTypes.bool,
        children: _react.PropTypes.node,
        headerComponent: _react.PropTypes.func,
        shouldAnimate: _react.PropTypes.bool,
        width: _react.PropTypes.number,
        offsetX: _react.PropTypes.number,
        linkComponent: _react.PropTypes.func,
        globalPrimaryItemHref: _react.PropTypes.string,
        globalPrimaryIcon: _react.PropTypes.node,
        globalSearchIcon: _react.PropTypes.node,
        globalCreateIcon: _react.PropTypes.node,
        onGlobalCreateActivate: _react.PropTypes.func,
        onGlobalSearchActivate: _react.PropTypes.func
    }, ContainerNavigation.defaultProps = {
        appearance: "container",
        areGlobalActionsVisible: !1,
        shouldAnimate: !1,
        width: _sharedVariables.containerOpenWidth,
        offsetX: 0,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = ContainerNavigation;
}, /* 44 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(45);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 45 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._3a1nvALsGNdXnElSTkTDfV{height:100%;position:fixed}._1RzEWkWc8kFgKd0b0NVcuM ._3a1nvALsGNdXnElSTkTDfV{-webkit-transition:width .2s,-webkit-transform .2s;transition:width .2s,-webkit-transform .2s;transition:width .2s,transform .2s;transition:width .2s,transform .2s,-webkit-transform .2s}._3zQ6LLojFMSA0YCi-qm3W-{box-sizing:border-box;background:#f4f5f7;color:#42526e;width:100%;height:100vh;overflow-x:hidden;overflow-y:auto;padding:24px 8px 0}._3zQ6LLojFMSA0YCi-qm3W- a,._3zQ6LLojFMSA0YCi-qm3W- a:hover,._3zQ6LLojFMSA0YCi-qm3W- a:visited{color:inherit;text-decoration:none}._3zQ6LLojFMSA0YCi-qm3W-:not(.ACr-F6rHvL83cqwVwRID0){padding-top:24px}._3zQ6LLojFMSA0YCi-qm3W-._1kmQE6NdRSo4xEL0PofRpv{background-color:#0049b0;color:#fff}._3zQ6LLojFMSA0YCi-qm3W-.ANzcHQkxV2qGyFU_YfFKR{background-color:#253858;color:#fff}", "" ]), 
    // exports
    exports.locals = {
        containerNavigationOuter: "_3a1nvALsGNdXnElSTkTDfV",
        containerNavigationOuter: "_3a1nvALsGNdXnElSTkTDfV",
        "should-animate": "_1RzEWkWc8kFgKd0b0NVcuM",
        shouldAnimate: "_1RzEWkWc8kFgKd0b0NVcuM",
        containerNavigationInner: "_3zQ6LLojFMSA0YCi-qm3W-",
        containerNavigationInner: "_3zQ6LLojFMSA0YCi-qm3W-",
        hasContainerHeader: "ACr-F6rHvL83cqwVwRID0",
        hasContainerHeader: "ACr-F6rHvL83cqwVwRID0",
        hasGlobalAppearance: "_1kmQE6NdRSo4xEL0PofRpv",
        hasGlobalAppearance: "_1kmQE6NdRSo4xEL0PofRpv",
        hasSettingsAppearance: "ANzcHQkxV2qGyFU_YfFKR",
        hasSettingsAppearance: "ANzcHQkxV2qGyFU_YfFKR"
    };
}, /* 46 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _taggedTemplateLiteral2 = __webpack_require__(47), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  transition: padding 200ms;\n  padding: ", ";\n  margin-bottom: ", 'px;\n\n  [data-__ak-navigation-container-closed="true"] & {\n    padding: ', ";\n  }\n" ], [ "\n  transition: padding 200ms;\n  padding: ", ";\n  margin-bottom: ", 'px;\n\n  [data-__ak-navigation-container-closed="true"] & {\n    padding: ', ";\n  }\n" ]), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(48), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(49), intGridSize = parseInt(_utilSharedStyles.akGridSize, 10), paddingOpen = "0 " + 1.75 * intGridSize + "px 0 " + 1.5 * intGridSize + "px", paddingClosed = "0 " + 2.5 * intGridSize + "px 0 " + .5 * intGridSize + "px", ContainerHeaderWrapper = _styledComponents2.default.div(_templateObject, paddingOpen, 1.5 * intGridSize, paddingClosed), ContainerHeader = function(_PureComponent) {
        function ContainerHeader() {
            return (0, _classCallCheck3.default)(this, ContainerHeader), (0, _possibleConstructorReturn3.default)(this, (ContainerHeader.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerHeader)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerHeader, _PureComponent), (0, _createClass3.default)(ContainerHeader, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement(ContainerHeaderWrapper, null, this.props.children);
            }
        } ]), ContainerHeader;
    }(_react.PureComponent);
    ContainerHeader.propTypes = {
        children: _react.PropTypes.node
    }, exports.default = ContainerHeader;
}, /* 47 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 48 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 49 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 50 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _Resizer = __webpack_require__(51), _Resizer2 = _interopRequireDefault(_Resizer), _ResizerButton = __webpack_require__(53), _ResizerButton2 = _interopRequireDefault(_ResizerButton), _sharedVariables = __webpack_require__(27), Resizer = function(_PureComponent) {
        function Resizer(props) {
            (0, _classCallCheck3.default)(this, Resizer);
            var _this = (0, _possibleConstructorReturn3.default)(this, (Resizer.__proto__ || (0, 
            _getPrototypeOf2.default)(Resizer)).call(this, props));
            return _this.mouseDownHandler = function(e) {
                e.preventDefault(), _this.resizerNode && e.target === _this.resizerNode && (_this.props.onResizeStart(), 
                _this.setState({
                    startScreenX: e.screenX
                }), document.addEventListener("mousemove", _this.mouseMoveHandler), document.addEventListener("mouseup", _this.mouseUpHandler));
            }, _this.mouseUpHandler = function(e) {
                _this.props.onResizeEnd(e.screenX - _this.state.startScreenX), document.removeEventListener("mousemove", _this.mouseMoveHandler), 
                document.removeEventListener("mouseup", _this.mouseUpHandler);
            }, _this.mouseMoveHandler = function(e) {
                _this.props.onResize(e.screenX - _this.state.startScreenX);
            }, _this.mouseEnterHandler = function() {
                _this.setState({
                    isHovering: !0
                });
            }, _this.mouseLeaveHandler = function() {
                _this.setState({
                    isHovering: !1
                });
            }, _this.isPointingRight = function() {
                return _this.props.navigationWidth < _sharedVariables.navigationOpenWidth;
            }, _this.resizeButtonHandler = function() {
                var isExpanded = _this.props.navigationWidth > _sharedVariables.navigationOpenWidth, isPointingRight = _this.isPointingRight();
                isPointingRight || isExpanded ? _this.props.onResizeButton({
                    isOpen: !0,
                    width: _sharedVariables.navigationOpenWidth
                }) : _this.props.onResizeButton({
                    isOpen: !1
                });
            }, _this.state = {
                startScreenX: 0,
                isHovering: !1,
                isResizing: !1
            }, _this;
        }
        return (0, _inherits3.default)(Resizer, _PureComponent), (0, _createClass3.default)(Resizer, [ {
            key: "render",
            value: function() {
                var _this2 = this;
                return _react2.default.createElement("div", {
                    ref: function(resizerNode) {
                        _this2.resizerNode = resizerNode;
                    },
                    className: _Resizer2.default.resizer,
                    onMouseDown: this.mouseDownHandler,
                    onMouseEnter: this.mouseEnterHandler,
                    onMouseLeave: this.mouseLeaveHandler
                }, _react2.default.createElement(_ResizerButton2.default, {
                    isVisible: this.state.isHovering,
                    isPointingRight: this.isPointingRight(),
                    onClick: this.resizeButtonHandler
                }));
            }
        } ]), Resizer;
    }(_react.PureComponent);
    Resizer.propTypes = {
        onResizeStart: _react.PropTypes.func,
        onResizeEnd: _react.PropTypes.func,
        onResizeButton: _react.PropTypes.func,
        onResize: _react.PropTypes.func,
        navigationWidth: _react.PropTypes.number
    }, Resizer.defaultProps = {
        onResizeStart: function() {},
        onResizeEnd: function() {},
        onResizeButton: function() {},
        onResize: function() {},
        navigationWidth: _sharedVariables.navigationOpenWidth
    }, exports.default = Resizer;
}, /* 51 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(52);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 52 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, ".wxD3Wkn0EtQ3g2tjqXkPe{height:100%;width:12px;position:relative;left:-6px;cursor:ew-resize}.wxD3Wkn0EtQ3g2tjqXkPe:hover:before{background:#2684ff}.wxD3Wkn0EtQ3g2tjqXkPe:before{content:'';width:2px;height:100%;position:absolute;left:5px}", "" ]), 
    // exports
    exports.locals = {
        resizer: "wxD3Wkn0EtQ3g2tjqXkPe",
        resizer: "wxD3Wkn0EtQ3g2tjqXkPe"
    };
}, /* 53 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _ResizerButton = __webpack_require__(54), _ResizerButton2 = _interopRequireDefault(_ResizerButton), ResizerButton = function(_PureComponent) {
        function ResizerButton() {
            return (0, _classCallCheck3.default)(this, ResizerButton), (0, _possibleConstructorReturn3.default)(this, (ResizerButton.__proto__ || (0, 
            _getPrototypeOf2.default)(ResizerButton)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ResizerButton, _PureComponent), (0, _createClass3.default)(ResizerButton, [ {
            key: "render",
            value: function() {
                var _classNames;
                return _react2.default.createElement("button", {
                    onMouseDown: function(e) {
                        return e.preventDefault();
                    },
                    onClick: this.props.onClick,
                    className: (0, _classnames2.default)(_ResizerButton2.default.button, (_classNames = {}, 
                    (0, _defineProperty3.default)(_classNames, _ResizerButton2.default.isVisible, this.props.isVisible), 
                    (0, _defineProperty3.default)(_classNames, _ResizerButton2.default.isPointingRight, this.props.isPointingRight), 
                    _classNames)),
                    "aria-expanded": !this.props.isPointingRight
                });
            }
        } ]), ResizerButton;
    }(_react.PureComponent);
    ResizerButton.propTypes = {
        isVisible: _react.PropTypes.bool,
        isPointingRight: _react.PropTypes.bool,
        onClick: _react.PropTypes.func
    }, exports.default = ResizerButton;
}, /* 54 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(55);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 55 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, ".kih_0XEb_GbHaeJEdiGT_{position:relative;top:calc(50% - 18px);height:36px;background:none;border:none;color:transparent;width:24px;left:0;cursor:pointer}.kih_0XEb_GbHaeJEdiGT_:focus{outline:none;box-shadow:0 0 0 2px #4c9aff}.kih_0XEb_GbHaeJEdiGT_._2KVFMw8DyPkLsczvrTAkyv:after,.kih_0XEb_GbHaeJEdiGT_._2KVFMw8DyPkLsczvrTAkyv:before{opacity:1}.kih_0XEb_GbHaeJEdiGT_:focus:after,.kih_0XEb_GbHaeJEdiGT_:focus:before,.kih_0XEb_GbHaeJEdiGT_:hover:after,.kih_0XEb_GbHaeJEdiGT_:hover:before{opacity:1}.kih_0XEb_GbHaeJEdiGT_:focus:before,.kih_0XEb_GbHaeJEdiGT_:hover:before{-webkit-transform:rotate(40deg);transform:rotate(40deg)}._1jXc6c6LId1Kkn0YpUqpN7.kih_0XEb_GbHaeJEdiGT_:focus:before,._1jXc6c6LId1Kkn0YpUqpN7.kih_0XEb_GbHaeJEdiGT_:hover:before{-webkit-transform:rotate(-40deg);transform:rotate(-40deg)}.kih_0XEb_GbHaeJEdiGT_:focus:after,.kih_0XEb_GbHaeJEdiGT_:hover:after{-webkit-transform:rotate(-40deg);transform:rotate(-40deg)}._1jXc6c6LId1Kkn0YpUqpN7.kih_0XEb_GbHaeJEdiGT_:focus:after,._1jXc6c6LId1Kkn0YpUqpN7.kih_0XEb_GbHaeJEdiGT_:hover:after{-webkit-transform:rotate(40deg);transform:rotate(40deg)}.kih_0XEb_GbHaeJEdiGT_:after,.kih_0XEb_GbHaeJEdiGT_:before{content:'';opacity:0;background:#2684ff;width:2px;border-radius:16px;height:8px;position:absolute;left:13px;-webkit-transition:opacity .3s cubic-bezier(.15,1,.3,1),-webkit-transform .2s ease-in-out;transition:opacity .3s cubic-bezier(.15,1,.3,1),-webkit-transform .2s ease-in-out;transition:transform .2s ease-in-out,opacity .3s cubic-bezier(.15,1,.3,1);transition:transform .2s ease-in-out,opacity .3s cubic-bezier(.15,1,.3,1),-webkit-transform .2s ease-in-out;-webkit-transform:rotate(0deg);transform:rotate(0deg)}.kih_0XEb_GbHaeJEdiGT_:before{top:10px;-webkit-transform-origin:1px 7px;transform-origin:1px 7px}.kih_0XEb_GbHaeJEdiGT_:after{top:16px;-webkit-transform-origin:1px 1px;transform-origin:1px 1px}", "" ]), 
    // exports
    exports.locals = {
        button: "kih_0XEb_GbHaeJEdiGT_",
        button: "kih_0XEb_GbHaeJEdiGT_",
        isVisible: "_2KVFMw8DyPkLsczvrTAkyv",
        isVisible: "_2KVFMw8DyPkLsczvrTAkyv",
        isPointingRight: "_1jXc6c6LId1Kkn0YpUqpN7",
        isPointingRight: "_1jXc6c6LId1Kkn0YpUqpN7"
    };
}, /* 56 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getContainerWidth(navigationWidth) {
        return navigationWidth > _sharedVariables.collapseBreakpoint ? navigationWidth - _sharedVariables.globalOpenWidth : Math.max(0, _sharedVariables.containerClosedWidth);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = getContainerWidth;
    var _sharedVariables = __webpack_require__(27);
}, /* 57 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _ContainerItem = __webpack_require__(58), _DefaultLinkComponent = __webpack_require__(37), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _NavigationItem = __webpack_require__(60), _NavigationItem2 = _interopRequireDefault(_NavigationItem), ContainerItem = function(_PureComponent) {
        function ContainerItem() {
            return (0, _classCallCheck3.default)(this, ContainerItem), (0, _possibleConstructorReturn3.default)(this, (ContainerItem.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerItem)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerItem, _PureComponent), (0, _createClass3.default)(ContainerItem, [ {
            key: "render",
            value: function() {
                var _className;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_ContainerItem.containerItem, (_className = {}, 
                    (0, _defineProperty3.default)(_className, _ContainerItem.hasGlobalAppearance, "global" === this.props.appearance), 
                    (0, _defineProperty3.default)(_className, _ContainerItem.hasSettingsAppearance, "settings" === this.props.appearance), 
                    (0, _defineProperty3.default)(_className, _ContainerItem.isSelected, this.props.isSelected), 
                    _className))
                }, _react2.default.createElement(_NavigationItem2.default, {
                    action: this.props.action,
                    href: this.props.href,
                    icon: this.props.icon,
                    isCompact: this.props.isCompact,
                    isSelected: this.props.isSelected,
                    linkComponent: this.props.linkComponent,
                    onClick: this.props.onClick,
                    subText: this.props.subText,
                    text: this.props.text,
                    textAfter: this.props.textAfter
                }));
            }
        } ]), ContainerItem;
    }(_react.PureComponent);
    ContainerItem.propTypes = {
        action: _react.PropTypes.node,
        appearance: _react.PropTypes.string,
        href: _react.PropTypes.string,
        icon: _react.PropTypes.node,
        isCompact: _react.PropTypes.bool,
        isSelected: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onClick: _react.PropTypes.func,
        subText: _react.PropTypes.string,
        text: _react.PropTypes.node,
        textAfter: _react.PropTypes.node
    }, ContainerItem.defaultProps = {
        isCompact: !1,
        isSelected: !1,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = ContainerItem;
}, /* 58 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(59);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 59 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._1XZP1hyAqyncBBum0P2LVX{border-radius:3px}._1XZP1hyAqyncBBum0P2LVX._1qJMdqKQmX1cJUbjFjc74p,._1XZP1hyAqyncBBum0P2LVX:hover{background:rgba(9,30,66,.04)}._1XZP1hyAqyncBBum0P2LVX._1qJMdqKQmX1cJUbjFjc74p._32DxcTPMPd7XfbsU6vM2qJ,._1XZP1hyAqyncBBum0P2LVX:hover._32DxcTPMPd7XfbsU6vM2qJ{color:#fff;background:rgba(9,30,66,.25)}._1XZP1hyAqyncBBum0P2LVX._1qJMdqKQmX1cJUbjFjc74p._1Uh0HcyDB_uKXSzsOGVWYA,._1XZP1hyAqyncBBum0P2LVX:hover._1Uh0HcyDB_uKXSzsOGVWYA{color:#fff;background:#091e42}._1qJMdqKQmX1cJUbjFjc74p{color:#0052cc}", "" ]), 
    // exports
    exports.locals = {
        containerItem: "_1XZP1hyAqyncBBum0P2LVX",
        containerItem: "_1XZP1hyAqyncBBum0P2LVX",
        isSelected: "_1qJMdqKQmX1cJUbjFjc74p",
        isSelected: "_1qJMdqKQmX1cJUbjFjc74p",
        hasGlobalAppearance: "_32DxcTPMPd7XfbsU6vM2qJ",
        hasGlobalAppearance: "_32DxcTPMPd7XfbsU6vM2qJ",
        hasSettingsAppearance: "_1Uh0HcyDB_uKXSzsOGVWYA",
        hasSettingsAppearance: "_1Uh0HcyDB_uKXSzsOGVWYA"
    };
}, /* 60 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _NavigationItem = __webpack_require__(61), _DefaultLinkComponent = __webpack_require__(37), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _InteractiveWrapper = __webpack_require__(63), _InteractiveWrapper2 = _interopRequireDefault(_InteractiveWrapper), NavigationItem = function(_PureComponent) {
        function NavigationItem() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, NavigationItem);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = NavigationItem.__proto__ || (0, 
            _getPrototypeOf2.default)(NavigationItem)).call.apply(_ref, [ this ].concat(args))), 
            _this.onMouseDown = function(e) {
                e.preventDefault();
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(NavigationItem, _PureComponent), (0, _createClass3.default)(NavigationItem, [ {
            key: "render",
            value: function() {
                var _classNames, _this2 = this, Icon = function() {
                    return _this2.props.icon ? _react2.default.createElement("div", {
                        className: _NavigationItem.icon
                    }, _this2.props.icon) : null;
                }, TextAfter = function() {
                    return _this2.props.textAfter ? _react2.default.createElement("div", {
                        className: _NavigationItem.textAfter
                    }, _this2.props.textAfter) : null;
                }, Action = function() {
                    return _this2.props.action ? _react2.default.createElement("div", {
                        className: _NavigationItem.action
                    }, _this2.props.action) : null;
                }, After = function(_ref2) {
                    var children = _ref2.children;
                    return _this2.props.textAfter ? _react2.default.createElement("div", {
                        className: _NavigationItem.after
                    }, children) : null;
                }, SubText = function() {
                    return _react2.default.createElement("div", {
                        className: _NavigationItem.subText
                    }, _this2.props.subText);
                };
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_NavigationItem.navigationItemOuter, (_classNames = {}, 
                    (0, _defineProperty3.default)(_classNames, _NavigationItem.isSelected, this.props.isSelected), 
                    (0, _defineProperty3.default)(_classNames, _NavigationItem.isCompact, this.props.isCompact), 
                    _classNames))
                }, _react2.default.createElement(_InteractiveWrapper2.default, {
                    className: _NavigationItem.link,
                    href: this.props.href,
                    onMouseDown: this.onMouseDown,
                    onClick: this.props.onClick,
                    linkComponent: this.props.linkComponent
                }, _react2.default.createElement("div", {
                    className: _NavigationItem.navigationItemInner
                }, _react2.default.createElement(Icon, null), _react2.default.createElement("div", {
                    className: _NavigationItem.text
                }, _react2.default.createElement("div", {
                    className: _NavigationItem.mainText
                }, this.props.text), _react2.default.createElement(SubText, null)), _react2.default.createElement(After, null, _react2.default.createElement(TextAfter, null)))), _react2.default.createElement(Action, null));
            }
        } ]), NavigationItem;
    }(_react.PureComponent);
    NavigationItem.propTypes = {
        action: _react.PropTypes.node,
        href: _react.PropTypes.string,
        icon: _react.PropTypes.node,
        isCompact: _react.PropTypes.bool,
        isSelected: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onClick: _react.PropTypes.func,
        subText: _react.PropTypes.string,
        text: _react.PropTypes.node,
        textAfter: _react.PropTypes.node
    }, NavigationItem.defaultProps = {
        isCompact: !1,
        isSelected: !1,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = NavigationItem;
}, /* 61 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(62);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 62 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._24E74lrr5BsCFFrm3v0eFP{width:100%;height:40px;box-sizing:border-box;text-overflow:ellipsis;position:relative}._24E74lrr5BsCFFrm3v0eFP ._2fpft_LfiGdEl_AEb3dVYM{padding:0}._24E74lrr5BsCFFrm3v0eFP:hover ._24E74lrr5BsCFFrm3v0eFP._2fpft_LfiGdEl_AEb3dVYM{padding:0}._24E74lrr5BsCFFrm3v0eFP a,._24E74lrr5BsCFFrm3v0eFP a:hover,._24E74lrr5BsCFFrm3v0eFP a:visited{color:inherit;text-decoration:none}._2YkrZd8_ZsC8L2idsLCoIy ._2MysK1wDpYttQvmJyjVKQl{padding-left:0;padding-right:8px}.zFPVCPce222k8eVnBqAm_{height:100%;width:100%;padding:0 8px;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;box-sizing:border-box}._2YkrZd8_ZsC8L2idsLCoIy{height:36px}._2YkrZd8_ZsC8L2idsLCoIy ._3bYB5CTfdpuTt5rgjwvTi-{font-size:10px;line-height:12px}._2etpSCzQRpnGD-A53mfqW_:focus{display:block;height:100%;border-radius:3px}._2etpSCzQRpnGD-A53mfqW_:focus:focus{outline:none;box-shadow:0 0 0 2px #4c9aff}.cvBlz7f4yORJVtHXMoRki{display:-webkit-box;display:flex;height:100%;-webkit-box-pack:center;justify-content:center;position:absolute;right:8px;top:0}[data-__ak-navigation-container-closed=true] .cvBlz7f4yORJVtHXMoRki{opacity:0}._2MysK1wDpYttQvmJyjVKQl{-webkit-transition:padding .2s;transition:padding .2s;padding:0 16px 0 12px;display:-webkit-box;display:flex;flex-shrink:0}[data-__ak-navigation-container-closed=true] ._2MysK1wDpYttQvmJyjVKQl{padding:0 4px}._2MysK1wDpYttQvmJyjVKQl>*{-webkit-box-flex:1;flex:1 0 auto;height:24px;width:24px}._3LGjRDTnslzTUjgePzJck9{min-width:24px}._1dyK4nlgnrBQKkJ_TpPxBV{overflow-x:hidden;display:inline-block;-webkit-box-flex:1;flex-grow:1}[data-__ak-navigation-container-closed=true] ._1dyK4nlgnrBQKkJ_TpPxBV{opacity:0}._1dyK4nlgnrBQKkJ_TpPxBV._3EI1KWPu6rQgBf9qQ7Kapi{margin-right:24px}._3Db1H7B463J07uvtZP4K7X{overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}._3bYB5CTfdpuTt5rgjwvTi-{color:#8993a4;font-size:.85714286em;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._3NfhGPlAN4coaP0IllTRHM{position:relative;z-index:1}[data-__ak-navigation-container-closed=true] ._3NfhGPlAN4coaP0IllTRHM{opacity:0}", "" ]), 
    // exports
    exports.locals = {
        navigationItemOuter: "_24E74lrr5BsCFFrm3v0eFP",
        navigationItemOuter: "_24E74lrr5BsCFFrm3v0eFP",
        isSelected: "_2fpft_LfiGdEl_AEb3dVYM",
        isSelected: "_2fpft_LfiGdEl_AEb3dVYM",
        isCompact: "_2YkrZd8_ZsC8L2idsLCoIy",
        isCompact: "_2YkrZd8_ZsC8L2idsLCoIy",
        icon: "_2MysK1wDpYttQvmJyjVKQl",
        icon: "_2MysK1wDpYttQvmJyjVKQl",
        navigationItemInner: "zFPVCPce222k8eVnBqAm_",
        navigationItemInner: "zFPVCPce222k8eVnBqAm_",
        subText: "_3bYB5CTfdpuTt5rgjwvTi-",
        subText: "_3bYB5CTfdpuTt5rgjwvTi-",
        link: "_2etpSCzQRpnGD-A53mfqW_",
        link: "_2etpSCzQRpnGD-A53mfqW_",
        action: "cvBlz7f4yORJVtHXMoRki",
        action: "cvBlz7f4yORJVtHXMoRki",
        after: "_3LGjRDTnslzTUjgePzJck9",
        after: "_3LGjRDTnslzTUjgePzJck9",
        text: "_1dyK4nlgnrBQKkJ_TpPxBV",
        text: "_1dyK4nlgnrBQKkJ_TpPxBV",
        hasTextAfterOrAction: "_3EI1KWPu6rQgBf9qQ7Kapi",
        hasTextAfterOrAction: "_3EI1KWPu6rQgBf9qQ7Kapi",
        mainText: "_3Db1H7B463J07uvtZP4K7X",
        mainText: "_3Db1H7B463J07uvtZP4K7X",
        textAfter: "_3NfhGPlAN4coaP0IllTRHM",
        textAfter: "_3NfhGPlAN4coaP0IllTRHM"
    };
}, /* 63 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _taggedTemplateLiteral2 = __webpack_require__(47), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: inherit;\n  background: none;\n  border: none;\n  box-sizing: content-box;\n  color: inherit;\n  cursor: pointer;\n  display: inline;\n  font: inherit;\n  height: 100%;\n  line-height: normal;\n  padding: 0;\n  text-align: inherit;\n  width: 100%;\n" ], [ "\n  align-items: inherit;\n  background: none;\n  border: none;\n  box-sizing: content-box;\n  color: inherit;\n  cursor: pointer;\n  display: inline;\n  font: inherit;\n  height: 100%;\n  line-height: normal;\n  padding: 0;\n  text-align: inherit;\n  width: 100%;\n" ]), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(48), _styledComponents2 = _interopRequireDefault(_styledComponents), InvisibleButton = _styledComponents2.default.button(_templateObject), InteractiveWrapper = function(_PureComponent) {
        function InteractiveWrapper() {
            return (0, _classCallCheck3.default)(this, InteractiveWrapper), (0, _possibleConstructorReturn3.default)(this, (InteractiveWrapper.__proto__ || (0, 
            _getPrototypeOf2.default)(InteractiveWrapper)).apply(this, arguments));
        }
        return (0, _inherits3.default)(InteractiveWrapper, _PureComponent), (0, _createClass3.default)(InteractiveWrapper, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, className = _props.className, href = _props.href, LinkComponent = _props.linkComponent, onClick = _props.onClick, onMouseDown = _props.onMouseDown;
                return href ? _react2.default.createElement(LinkComponent, {
                    onMouseDown: onMouseDown,
                    onClick: onClick,
                    href: href,
                    className: className
                }, children) : _react2.default.createElement(InvisibleButton, {
                    className: className,
                    onClick: onClick,
                    onMouseDown: onMouseDown
                }, children);
            }
        } ]), InteractiveWrapper;
    }(_react.PureComponent);
    InteractiveWrapper.propTypes = {
        children: _react.PropTypes.node,
        className: _react.PropTypes.string,
        href: _react.PropTypes.string,
        linkComponent: _react.PropTypes.func,
        onClick: _react.PropTypes.func,
        onMouseDown: _react.PropTypes.func
    }, exports.default = InteractiveWrapper;
}, /* 64 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _ContainerItemGroup = __webpack_require__(65), _ContainerItemGroup2 = _interopRequireDefault(_ContainerItemGroup), ContainerItemGroup = function(_PureComponent) {
        function ContainerItemGroup() {
            return (0, _classCallCheck3.default)(this, ContainerItemGroup), (0, _possibleConstructorReturn3.default)(this, (ContainerItemGroup.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerItemGroup)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerItemGroup, _PureComponent), (0, _createClass3.default)(ContainerItemGroup, [ {
            key: "render",
            value: function() {
                var _className2, _props = this.props, title = _props.title, action = _props.action, hasSeparator = _props.hasSeparator, appearance = _props.appearance, Title = function() {
                    return title ? _react2.default.createElement("div", {
                        className: _ContainerItemGroup2.default.title
                    }, _react2.default.createElement("span", null, title)) : null;
                };
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _ContainerItemGroup2.default.noHeaderContent, !(title || action || hasSeparator)))
                }, hasSeparator ? _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_ContainerItemGroup2.default.separator, (_className2 = {}, 
                    (0, _defineProperty3.default)(_className2, _ContainerItemGroup2.default.hasGlobalAppearance, "global" === appearance), 
                    (0, _defineProperty3.default)(_className2, _ContainerItemGroup2.default.hasSettingsAppearance, "settings" === appearance), 
                    _className2))
                }) : null, title || action ? _react2.default.createElement("div", {
                    className: _ContainerItemGroup2.default.header
                }, _react2.default.createElement(Title, null), this.props.action ? _react2.default.createElement("div", {
                    className: _ContainerItemGroup2.default.action
                }, this.props.action) : null) : null, _react2.default.createElement("div", null, this.props.children));
            }
        } ]), ContainerItemGroup;
    }(_react.PureComponent);
    ContainerItemGroup.propTypes = {
        action: _react.PropTypes.node,
        children: _react.PropTypes.node,
        title: _react.PropTypes.string,
        hasSeparator: _react.PropTypes.bool,
        appearance: _react.PropTypes.string
    }, exports.default = ContainerItemGroup;
}, /* 65 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(66);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 66 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._8qL3FXgqAme4obE1p5cC1{display:-webkit-box;display:flex;margin-bottom:8px;margin-left:8px;margin-top:16px}[data-__ak-navigation-container-closed=true] ._8qL3FXgqAme4obE1p5cC1{margin-left:4px;margin-right:4px;border-top:1px solid rgba(9,30,66,.13)}[data-__ak-navigation-container-closed=true] ._8qL3FXgqAme4obE1p5cC1 ._1l1BufRLh43bGr9inznYRG,[data-__ak-navigation-container-closed=true] ._8qL3FXgqAme4obE1p5cC1 ._1UDBWXy_FAeyXhL6Zk_mw7{visibility:hidden}._2kg-VV5XGNlDaLnrrzkAA2{margin-top:24px}._2kg-VV5XGNlDaLnrrzkAA2:first-child{margin-top:0}._1l1BufRLh43bGr9inznYRG{align-self:center;color:#8993a4;display:-webkit-box;display:flex;-webkit-box-flex:1;flex-grow:1;font-size:12px;text-transform:uppercase}._1UDBWXy_FAeyXhL6Zk_mw7{margin-right:8px}._3Genx9m60e4e7snDqmV2-j{margin-top:19px;margin-bottom:19px;height:2px;background:rgba(9,30,66,.04)}._3Genx9m60e4e7snDqmV2-j._2wNa9OHOAQZioeiL2c9_NO{background:rgba(9,30,66,.25)}._3Genx9m60e4e7snDqmV2-j._2sfJr-7PxzES7zKsRJ-TdN{background:#091e42}", "" ]), 
    // exports
    exports.locals = {
        header: "_8qL3FXgqAme4obE1p5cC1",
        header: "_8qL3FXgqAme4obE1p5cC1",
        title: "_1l1BufRLh43bGr9inznYRG",
        title: "_1l1BufRLh43bGr9inznYRG",
        action: "_1UDBWXy_FAeyXhL6Zk_mw7",
        action: "_1UDBWXy_FAeyXhL6Zk_mw7",
        noHeaderContent: "_2kg-VV5XGNlDaLnrrzkAA2",
        noHeaderContent: "_2kg-VV5XGNlDaLnrrzkAA2",
        separator: "_3Genx9m60e4e7snDqmV2-j",
        separator: "_3Genx9m60e4e7snDqmV2-j",
        hasGlobalAppearance: "_2wNa9OHOAQZioeiL2c9_NO",
        hasGlobalAppearance: "_2wNa9OHOAQZioeiL2c9_NO",
        hasSettingsAppearance: "_2sfJr-7PxzES7zKsRJ-TdN",
        hasSettingsAppearance: "_2sfJr-7PxzES7zKsRJ-TdN"
    };
}, /* 67 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _ContainerLogo = __webpack_require__(68), _ContainerLogo2 = _interopRequireDefault(_ContainerLogo), ContainerLogo = function(_PureComponent) {
        function ContainerLogo() {
            return (0, _classCallCheck3.default)(this, ContainerLogo), (0, _possibleConstructorReturn3.default)(this, (ContainerLogo.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerLogo)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerLogo, _PureComponent), (0, _createClass3.default)(ContainerLogo, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: _ContainerLogo2.default.containerLogo
                }, this.props.children);
            }
        } ]), ContainerLogo;
    }(_react.PureComponent);
    ContainerLogo.propTypes = {
        children: _react.PropTypes.node
    }, exports.default = ContainerLogo;
}, /* 68 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(69);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 69 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._3xolabbmXmkyj79LFbtkvk{height:24px;margin:28px 0 28px 24px}", "" ]), 
    // exports
    exports.locals = {
        containerLogo: "_3xolabbmXmkyj79LFbtkvk",
        containerLogo: "_3xolabbmXmkyj79LFbtkvk"
    };
}, /* 70 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _ContainerTitle = __webpack_require__(71), _ContainerTitle2 = _interopRequireDefault(_ContainerTitle), _DefaultLinkComponent = __webpack_require__(37), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), ContainerTitle = function(_PureComponent) {
        function ContainerTitle() {
            return (0, _classCallCheck3.default)(this, ContainerTitle), (0, _possibleConstructorReturn3.default)(this, (ContainerTitle.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerTitle)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerTitle, _PureComponent), (0, _createClass3.default)(ContainerTitle, [ {
            key: "render",
            value: function() {
                var _className, _props = this.props, appearance = _props.appearance, href = _props.href, text = _props.text, subText = _props.subText, Link = _props.linkComponent;
                return _react2.default.createElement(Link, {
                    className: _ContainerTitle2.default.link,
                    href: href
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_ContainerTitle2.default.containerTitle, (_className = {}, 
                    (0, _defineProperty3.default)(_className, _ContainerTitle2.default.hasGlobalAppearance, "global" === appearance), 
                    (0, _defineProperty3.default)(_className, _ContainerTitle2.default.hasSettingsAppearance, "settings" === appearance), 
                    _className))
                }, _react2.default.createElement("div", {
                    className: _ContainerTitle2.default.icon
                }, this.props.icon), _react2.default.createElement("div", {
                    className: _ContainerTitle2.default.textContainer
                }, _react2.default.createElement("div", {
                    className: _ContainerTitle2.default.text
                }, text), subText ? _react2.default.createElement("div", {
                    className: _ContainerTitle2.default.subText
                }, subText) : null)));
            }
        } ]), ContainerTitle;
    }(_react.PureComponent);
    ContainerTitle.propTypes = {
        appearance: _react.PropTypes.string,
        icon: _react.PropTypes.node,
        text: _react.PropTypes.string,
        subText: _react.PropTypes.string,
        href: _react.PropTypes.string,
        linkComponent: _react.PropTypes.func
    }, ContainerTitle.defaultProps = {
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = ContainerTitle;
}, /* 71 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(72);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 72 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._3QySvLkR_mEQM1VICfSmzQ{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;align-content:center;padding-bottom:4px}._2v7qCatqYLjsT7wL2opfy9{text-decoration:none}._2v7qCatqYLjsT7wL2opfy9:hover{color:#505f79;text-decoration:none}._1biSwQ0XN4tDZwt0CQ2nts{width:40px;height:40px}._1biSwQ0XN4tDZwt0CQ2nts>*{width:40px;height:40px;border-radius:4px}.YVFdFpdbkuB9cbVa_NLHc{margin-left:8px;width:100%;min-width:0}[data-__ak-navigation-container-closed=true] .YVFdFpdbkuB9cbVa_NLHc{display:none}._39LXdxEGnBZKJ_zuxMqN1A ._1j5KT89QEjDcn1JwpeVmCx,._39LXdxEGnBZKJ_zuxMqN1A ._2KTW6Hbzn3z1j3o6UFbl6s,.r_hj5I2Sl-ES1up0umflw ._1j5KT89QEjDcn1JwpeVmCx,.r_hj5I2Sl-ES1up0umflw ._2KTW6Hbzn3z1j3o6UFbl6s{color:#fff}._1j5KT89QEjDcn1JwpeVmCx{color:#42526e;font-weight:500;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}._2KTW6Hbzn3z1j3o6UFbl6s{color:#5e6c84;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}", "" ]), 
    // exports
    exports.locals = {
        containerTitle: "_3QySvLkR_mEQM1VICfSmzQ",
        containerTitle: "_3QySvLkR_mEQM1VICfSmzQ",
        link: "_2v7qCatqYLjsT7wL2opfy9",
        link: "_2v7qCatqYLjsT7wL2opfy9",
        icon: "_1biSwQ0XN4tDZwt0CQ2nts",
        icon: "_1biSwQ0XN4tDZwt0CQ2nts",
        textContainer: "YVFdFpdbkuB9cbVa_NLHc",
        textContainer: "YVFdFpdbkuB9cbVa_NLHc",
        hasGlobalAppearance: "r_hj5I2Sl-ES1up0umflw",
        hasGlobalAppearance: "r_hj5I2Sl-ES1up0umflw",
        text: "_1j5KT89QEjDcn1JwpeVmCx",
        text: "_1j5KT89QEjDcn1JwpeVmCx",
        hasSettingsAppearance: "_39LXdxEGnBZKJ_zuxMqN1A",
        hasSettingsAppearance: "_39LXdxEGnBZKJ_zuxMqN1A",
        subText: "_2KTW6Hbzn3z1j3o6UFbl6s",
        subText: "_2KTW6Hbzn3z1j3o6UFbl6s"
    };
}, /* 73 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _ContainerNavigationNested = __webpack_require__(74), _ContainerNavigationNested2 = _interopRequireDefault(_ContainerNavigationNested), ContainerNavigationNested = function(_PureComponent) {
        function ContainerNavigationNested(props) {
            (0, _classCallCheck3.default)(this, ContainerNavigationNested);
            var _this = (0, _possibleConstructorReturn3.default)(this, (ContainerNavigationNested.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerNavigationNested)).call(this, props));
            return _this.animationEndHandler = function() {
                "left" === _this.props.animationDirection ? (_this.animateContainer.classList.remove(_ContainerNavigationNested2.default.containerNavigationNestedLeftAnimate), 
                _this.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedLeftAnimateEnd)) : (_this.animateContainer.classList.remove(_ContainerNavigationNested2.default.containerNavigationNestedRightAnimate), 
                _this.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedRightAnimateEnd)), 
                _this.props.onAnimationEnd();
            }, _this.state = {}, _this;
        }
        return (0, _inherits3.default)(ContainerNavigationNested, _PureComponent), (0, _createClass3.default)(ContainerNavigationNested, [ {
            key: "componentWillUpdate",
            value: function(nextProps) {
                nextProps.children !== this.props.children && this.setState({
                    prevChildren: this.props.children
                });
            }
        }, {
            key: "componentDidUpdate",
            value: function() {
                this.animateContainer.className = _ContainerNavigationNested2.default.containerNavigationNested, 
                // handle left animation
                "left" === this.props.animationDirection && this.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedLeftAnimate), 
                // handle right animation
                "right" === this.props.animationDirection && this.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedRightAnimate);
            }
        }, {
            key: "render",
            value: function() {
                var _this2 = this, children = this.props.children, prevChildren = this.state.prevChildren, activePane = _react2.default.createElement("div", {
                    key: "active-pane",
                    className: _ContainerNavigationNested2.default.pageWrapper
                }, children), prevPane = _react2.default.createElement("div", {
                    key: "prev-pane",
                    className: _ContainerNavigationNested2.default.pageWrapper
                }, prevChildren), content = "left" === this.props.animationDirection ? [ prevPane, activePane ] : [ activePane, prevPane ];
                return _react2.default.createElement("div", {
                    className: _ContainerNavigationNested2.default.containerNavigationNested,
                    onAnimationEnd: this.animationEndHandler,
                    ref: function(el) {
                        _this2.animateContainer = el;
                    }
                }, content);
            }
        } ]), ContainerNavigationNested;
    }(_react.PureComponent);
    ContainerNavigationNested.propTypes = {
        children: _react.PropTypes.node,
        onAnimationEnd: _react.PropTypes.func,
        animationDirection: _react.PropTypes.oneOf([ "left", "right" ])
    }, ContainerNavigationNested.defaultProps = {
        onAnimationEnd: function() {}
    }, exports.default = ContainerNavigationNested;
}, /* 74 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(75);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 75 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._2yXEkB00Wa4yqnac8L-V8j{display:-webkit-box;display:flex;position:relative;margin:0 -8px}._2iOT8GEeve5WNRrkJYMxKH{-webkit-box-flex:1;flex:1 0 100%;overflow:hidden;box-sizing:border-box;padding:0 8px}._17BT7mKI95gM1EPhzMFsj0{-webkit-animation-name:_3uHYIb1z6tD5wa-cjnWjau;animation-name:_3uHYIb1z6tD5wa-cjnWjau;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}._3SB3l6SE7zXFhwRznGRZd3{-webkit-transform:translateX(-100%);transform:translateX(-100%)}@-webkit-keyframes _3uHYIb1z6tD5wa-cjnWjau{0%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}@keyframes _3uHYIb1z6tD5wa-cjnWjau{0%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}.mtusTHF7sKPCK240dZGhg{-webkit-animation-name:_19dajzFZYMCZm5tceFh0ig;animation-name:_19dajzFZYMCZm5tceFh0ig;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}._34WV8KNT7G1_3Zr56dv8FU{-webkit-transform:translateX(0);transform:translateX(0)}@-webkit-keyframes _19dajzFZYMCZm5tceFh0ig{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes _19dajzFZYMCZm5tceFh0ig{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(0);transform:translateX(0)}}", "" ]), 
    // exports
    exports.locals = {
        containerNavigationNested: "_2yXEkB00Wa4yqnac8L-V8j",
        containerNavigationNested: "_2yXEkB00Wa4yqnac8L-V8j",
        pageWrapper: "_2iOT8GEeve5WNRrkJYMxKH",
        pageWrapper: "_2iOT8GEeve5WNRrkJYMxKH",
        containerNavigationNestedLeftAnimate: "_17BT7mKI95gM1EPhzMFsj0",
        containerNavigationNestedLeftAnimate: "_17BT7mKI95gM1EPhzMFsj0",
        slideLeft: "_3uHYIb1z6tD5wa-cjnWjau",
        slideLeft: "_3uHYIb1z6tD5wa-cjnWjau",
        containerNavigationNestedLeftAnimateEnd: "_3SB3l6SE7zXFhwRznGRZd3",
        containerNavigationNestedLeftAnimateEnd: "_3SB3l6SE7zXFhwRznGRZd3",
        containerNavigationNestedRightAnimate: "mtusTHF7sKPCK240dZGhg",
        containerNavigationNestedRightAnimate: "mtusTHF7sKPCK240dZGhg",
        slideRight: "_19dajzFZYMCZm5tceFh0ig",
        slideRight: "_19dajzFZYMCZm5tceFh0ig",
        containerNavigationNestedRightAnimateEnd: "_34WV8KNT7G1_3Zr56dv8FU",
        containerNavigationNestedRightAnimateEnd: "_34WV8KNT7G1_3Zr56dv8FU"
    };
}, /* 76 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _taggedTemplateLiteral2 = __webpack_require__(47), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  position: absolute;\n  transition: top 220ms;\n  top: ", "px;\n  width: calc(100% - 16px);\n" ], [ "\n  position: absolute;\n  transition: top 220ms;\n  top: ", "px;\n  width: calc(100% - 16px);\n" ]), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(48), _styledComponents2 = _interopRequireDefault(_styledComponents), _Drawer = __webpack_require__(77), _Drawer2 = _interopRequireDefault(_Drawer), _sharedVariables = __webpack_require__(27), ContentArea = _styledComponents2.default.div(_templateObject, function(props) {
        return props.isFullWidth ? 0 : _sharedVariables.createIconOffset;
    }), CreateDrawer = function(_PureComponent) {
        function CreateDrawer() {
            return (0, _classCallCheck3.default)(this, CreateDrawer), (0, _possibleConstructorReturn3.default)(this, (CreateDrawer.__proto__ || (0, 
            _getPrototypeOf2.default)(CreateDrawer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(CreateDrawer, _PureComponent), (0, _createClass3.default)(CreateDrawer, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, backIcon = _props.backIcon, header = _props.header, isFullWidth = _props.isFullWidth, isOpen = _props.isOpen, onBackButton = _props.onBackButton, primaryIcon = _props.primaryIcon;
                return _react2.default.createElement(_Drawer2.default, {
                    backIcon: backIcon,
                    header: header,
                    isOpen: isOpen,
                    width: isFullWidth ? "full" : "narrow",
                    onBackButton: onBackButton,
                    primaryIcon: primaryIcon,
                    backIconOffset: _sharedVariables.createIconOffset
                }, _react2.default.createElement(ContentArea, {
                    isFullWidth: isFullWidth
                }, children));
            }
        } ]), CreateDrawer;
    }(_react.PureComponent);
    CreateDrawer.propTypes = {
        backIcon: _react.PropTypes.node,
        children: _react.PropTypes.node,
        header: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        isFullWidth: _react.PropTypes.bool,
        onBackButton: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node
    }, exports.default = CreateDrawer;
}, /* 77 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _blanket = __webpack_require__(78), _blanket2 = _interopRequireDefault(_blanket), _Drawer = __webpack_require__(79), _Drawer2 = _interopRequireDefault(_Drawer), _DrawerTrigger = __webpack_require__(38), _DrawerTrigger2 = _interopRequireDefault(_DrawerTrigger), _DrawerBackIcon = __webpack_require__(81), _DrawerBackIcon2 = _interopRequireDefault(_DrawerBackIcon), _ContainerHeader = __webpack_require__(46), _ContainerHeader2 = _interopRequireDefault(_ContainerHeader), Drawer = function(_PureComponent) {
        function Drawer() {
            return (0, _classCallCheck3.default)(this, Drawer), (0, _possibleConstructorReturn3.default)(this, (Drawer.__proto__ || (0, 
            _getPrototypeOf2.default)(Drawer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Drawer, _PureComponent), (0, _createClass3.default)(Drawer, [ {
            key: "render",
            value: function() {
                var _classNames, _props = this.props, backIcon = _props.backIcon, backIconOffset = _props.backIconOffset, header = _props.header, isOpen = _props.isOpen, onBackButton = _props.onBackButton, primaryIcon = _props.primaryIcon, width = _props.width, backIconOuterStyle = {
                    top: backIconOffset + "px"
                };
                return _react2.default.createElement("div", null, _react2.default.createElement("div", {
                    style: {
                        zIndex: 0,
                        position: "relative"
                    }
                }, _react2.default.createElement(_blanket2.default, {
                    isTinted: isOpen,
                    canClickThrough: !isOpen,
                    onBlanketClicked: onBackButton
                })), _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.drawer, (_classNames = {}, 
                    (0, _defineProperty3.default)(_classNames, _Drawer2.default.open, isOpen), (0, _defineProperty3.default)(_classNames, _Drawer2.default.wideWidth, "wide" === width), 
                    (0, _defineProperty3.default)(_classNames, _Drawer2.default.fullWidth, "full" === width), 
                    _classNames))
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.fixed, _Drawer2.default.side)
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.icon)
                }, primaryIcon), _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.backIconOuter),
                    style: backIconOuterStyle
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.backIcon)
                }, _react2.default.createElement(_DrawerTrigger2.default, {
                    onActivate: onBackButton
                }, _react2.default.createElement(_DrawerBackIcon2.default, {
                    isVisible: isOpen
                }, backIcon))))), _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.main)
                }, "full" !== width ? _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.fixed, _Drawer2.default.header)
                }, _react2.default.createElement(_ContainerHeader2.default, null, header)) : null, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.content)
                }, this.props.children))));
            }
        } ]), Drawer;
    }(_react.PureComponent);
    Drawer.propTypes = {
        backIcon: _react.PropTypes.node,
        backIconOffset: _react.PropTypes.number,
        children: _react.PropTypes.node,
        header: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        onBackButton: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node,
        width: _react.PropTypes.oneOf([ "narrow", "wide", "full" ])
    }, Drawer.defaultProps = {
        backIconOffset: 0,
        onBackButton: function() {},
        primaryIcon: null,
        width: "narrow",
        isOpen: !1
    }, exports.default = Drawer;
}, /* 78 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/blanket");
}, /* 79 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(80);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 80 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._1ETFVe3vxopmFZ2k6Th_El{display:none}._3IcsAaPLL8mNDshsDcj4pX{background:#fff;box-shadow:-32px 0 32px 32px rgba(23,43,77,.24);color:#42526e;display:-webkit-box;display:flex;height:100%;left:0;overflow:hidden;position:fixed;-webkit-transform:translateX(-392px);transform:translateX(-392px);-webkit-transition:width .22s cubic-bezier(.15,1,.3,1),-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:width .22s cubic-bezier(.15,1,.3,1),-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1),width .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1),width .22s cubic-bezier(.15,1,.3,1),-webkit-transform .22s cubic-bezier(.15,1,.3,1);width:360px}._3IcsAaPLL8mNDshsDcj4pX:not(._21_lWzyBICq_i6nO0kWRVn){box-shadow:none}._3IcsAaPLL8mNDshsDcj4pX.NLExp7wo7Ru1bTrfF0MZp{width:600px;-webkit-transform:translateX(-632px);transform:translateX(-632px)}._3IcsAaPLL8mNDshsDcj4pX._2i65-9k-gl-ML32TNuK9IO{width:100vw;-webkit-transform:translateX(-132vw);transform:translateX(-132vw)}._3IcsAaPLL8mNDshsDcj4pX._2i65-9k-gl-ML32TNuK9IO._21_lWzyBICq_i6nO0kWRVn,._3IcsAaPLL8mNDshsDcj4pX._21_lWzyBICq_i6nO0kWRVn,._3IcsAaPLL8mNDshsDcj4pX.NLExp7wo7Ru1bTrfF0MZp._21_lWzyBICq_i6nO0kWRVn{-webkit-transform:translateX(0);transform:translateX(0)}._3w4d8t5nnHR7IP_XQ1lux0{min-height:56px;padding-top:8px}._1i-qK0bRcEpJANhIe4tHkV{-webkit-box-align:center;align-items:center;box-sizing:border-box;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-flex:1;flex:1 0 auto;padding:24px 0 16px;width:64px}._1i-qK0bRcEpJANhIe4tHkV ._2ZNBQGx89KZCUgajrPEhbS{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;height:40px;-webkit-box-pack:center;justify-content:center;width:40px}._1i-qK0bRcEpJANhIe4tHkV ._2-D8-f2YWBX5EyN_ejJeSF{position:absolute}._3c0wbOW-m5qsNjIpkilOXd{box-sizing:border-box;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;height:100%;overflow-y:auto;padding:16px 8px 0;position:relative;width:100%}._1kWbMB5n0DO6Q5mQMpfN0p{width:100%}._3kXf-pZl5hScvyk8ks--9i{-webkit-transition:-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1),-webkit-transform .22s cubic-bezier(.15,1,.3,1);-webkit-transform:translateX(392px);transform:translateX(392px)}.NLExp7wo7Ru1bTrfF0MZp ._3kXf-pZl5hScvyk8ks--9i{-webkit-transform:translateX(632px);transform:translateX(632px)}._2i65-9k-gl-ML32TNuK9IO ._3kXf-pZl5hScvyk8ks--9i{-webkit-transform:translateX(132vw);transform:translateX(132vw)}._2i65-9k-gl-ML32TNuK9IO._21_lWzyBICq_i6nO0kWRVn ._3kXf-pZl5hScvyk8ks--9i,._21_lWzyBICq_i6nO0kWRVn ._3kXf-pZl5hScvyk8ks--9i,.NLExp7wo7Ru1bTrfF0MZp._21_lWzyBICq_i6nO0kWRVn ._3kXf-pZl5hScvyk8ks--9i{-webkit-transform:translateX(0);transform:translateX(0)}", "" ]), 
    // exports
    exports.locals = {
        hidden: "_1ETFVe3vxopmFZ2k6Th_El",
        hidden: "_1ETFVe3vxopmFZ2k6Th_El",
        drawer: "_3IcsAaPLL8mNDshsDcj4pX",
        drawer: "_3IcsAaPLL8mNDshsDcj4pX",
        open: "_21_lWzyBICq_i6nO0kWRVn",
        open: "_21_lWzyBICq_i6nO0kWRVn",
        "wide-width": "NLExp7wo7Ru1bTrfF0MZp",
        wideWidth: "NLExp7wo7Ru1bTrfF0MZp",
        "full-width": "_2i65-9k-gl-ML32TNuK9IO",
        fullWidth: "_2i65-9k-gl-ML32TNuK9IO",
        header: "_3w4d8t5nnHR7IP_XQ1lux0",
        header: "_3w4d8t5nnHR7IP_XQ1lux0",
        side: "_1i-qK0bRcEpJANhIe4tHkV",
        side: "_1i-qK0bRcEpJANhIe4tHkV",
        icon: "_2ZNBQGx89KZCUgajrPEhbS",
        icon: "_2ZNBQGx89KZCUgajrPEhbS",
        backIconOuter: "_2-D8-f2YWBX5EyN_ejJeSF",
        backIconOuter: "_2-D8-f2YWBX5EyN_ejJeSF",
        main: "_3c0wbOW-m5qsNjIpkilOXd",
        main: "_3c0wbOW-m5qsNjIpkilOXd",
        content: "_1kWbMB5n0DO6Q5mQMpfN0p",
        content: "_1kWbMB5n0DO6Q5mQMpfN0p",
        fixed: "_3kXf-pZl5hScvyk8ks--9i",
        fixed: "_3kXf-pZl5hScvyk8ks--9i"
    };
}, /* 81 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(23), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _DrawerBackIcon = __webpack_require__(82), _DrawerBackIcon2 = _interopRequireDefault(_DrawerBackIcon), DrawerBackIcon = function(_PureComponent) {
        function DrawerBackIcon() {
            return (0, _classCallCheck3.default)(this, DrawerBackIcon), (0, _possibleConstructorReturn3.default)(this, (DrawerBackIcon.__proto__ || (0, 
            _getPrototypeOf2.default)(DrawerBackIcon)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DrawerBackIcon, _PureComponent), (0, _createClass3.default)(DrawerBackIcon, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, isVisible = _props.isVisible;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_DrawerBackIcon2.default.backIcon, (0, _defineProperty3.default)({}, _DrawerBackIcon2.default.isVisible, isVisible))
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_DrawerBackIcon2.default.icon)
                }, children));
            }
        } ]), DrawerBackIcon;
    }(_react.PureComponent);
    DrawerBackIcon.propTypes = {
        children: _react.PropTypes.node,
        isVisible: _react.PropTypes.bool
    }, DrawerBackIcon.defaultProps = {
        isVisible: !1
    }, exports.default = DrawerBackIcon;
}, /* 82 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(83);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 83 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._3ZFfntUhCJhQclXvfnVMY3{background:#f4f5f7;border-radius:50%;color:#42526e;cursor:pointer;display:-webkit-box;display:flex;height:40px;-webkit-box-pack:center;justify-content:center;width:40px}._3ZFfntUhCJhQclXvfnVMY3:active{background:#deebff;color:#0052cc}._3ZFfntUhCJhQclXvfnVMY3 ._1ZsGSa4o8lS91EVOt6iuwD{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-transform:translatex(-16px);transform:translatex(-16px);-webkit-transition:-webkit-transform .22s;transition:-webkit-transform .22s;transition:transform .22s;transition:transform .22s,-webkit-transform .22s}._3ZFfntUhCJhQclXvfnVMY3._1vUfNgyUAYf4zxPZ6zLRhS ._1ZsGSa4o8lS91EVOt6iuwD{-webkit-transform:translateX(0);transform:translateX(0)}", "" ]), 
    // exports
    exports.locals = {
        backIcon: "_3ZFfntUhCJhQclXvfnVMY3",
        backIcon: "_3ZFfntUhCJhQclXvfnVMY3",
        icon: "_1ZsGSa4o8lS91EVOt6iuwD",
        icon: "_1ZsGSa4o8lS91EVOt6iuwD",
        isVisible: "_1vUfNgyUAYf4zxPZ6zLRhS",
        isVisible: "_1vUfNgyUAYf4zxPZ6zLRhS"
    };
}, /* 84 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _taggedTemplateLiteral2 = __webpack_require__(47), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  position: absolute;\n  transition: top 220ms;\n  top: ", "px;\n  width: calc(100% - 16px);\n" ], [ "\n  position: absolute;\n  transition: top 220ms;\n  top: ", "px;\n  width: calc(100% - 16px);\n" ]), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(48), _styledComponents2 = _interopRequireDefault(_styledComponents), _Drawer = __webpack_require__(77), _Drawer2 = _interopRequireDefault(_Drawer), _sharedVariables = __webpack_require__(27), ContentArea = _styledComponents2.default.div(_templateObject, function(props) {
        return props.isFullWidth ? 0 : _sharedVariables.searchIconOffset;
    }), CustomDrawer = function(_PureComponent) {
        function CustomDrawer() {
            return (0, _classCallCheck3.default)(this, CustomDrawer), (0, _possibleConstructorReturn3.default)(this, (CustomDrawer.__proto__ || (0, 
            _getPrototypeOf2.default)(CustomDrawer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(CustomDrawer, _PureComponent), (0, _createClass3.default)(CustomDrawer, [ {
            key: "render",
            value: function() {
                var _props = this.props, backIcon = _props.backIcon, children = _props.children, header = _props.header, isOpen = _props.isOpen, onBackButton = _props.onBackButton, primaryIcon = _props.primaryIcon, width = _props.width;
                return _react2.default.createElement(_Drawer2.default, {
                    backIcon: backIcon,
                    backIconOffset: _sharedVariables.searchIconOffset,
                    header: header,
                    isOpen: isOpen,
                    onBackButton: onBackButton,
                    primaryIcon: primaryIcon,
                    width: width
                }, _react2.default.createElement(ContentArea, {
                    isFullWidth: "full" === width
                }, children));
            }
        } ]), CustomDrawer;
    }(_react.PureComponent);
    CustomDrawer.propTypes = {
        backIcon: _react.PropTypes.node,
        children: _react.PropTypes.node,
        header: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        onBackButton: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node,
        width: _react.PropTypes.oneOf([ "narrow", "wide", "full" ])
    }, CustomDrawer.defaultProps = {
        width: "wide"
    }, exports.default = CustomDrawer;
}, /* 85 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _taggedTemplateLiteral2 = __webpack_require__(47), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  position: absolute;\n  transition: top 220ms;\n  top: ", "px;\n  width: calc(100% - 16px);\n" ], [ "\n  position: absolute;\n  transition: top 220ms;\n  top: ", "px;\n  width: calc(100% - 16px);\n" ]), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(48), _styledComponents2 = _interopRequireDefault(_styledComponents), _Drawer = __webpack_require__(77), _Drawer2 = _interopRequireDefault(_Drawer), _sharedVariables = __webpack_require__(27), ContentArea = _styledComponents2.default.div(_templateObject, function(props) {
        return props.isFullWidth ? 0 : _sharedVariables.searchIconOffset;
    }), SearchDrawer = function(_PureComponent) {
        function SearchDrawer() {
            return (0, _classCallCheck3.default)(this, SearchDrawer), (0, _possibleConstructorReturn3.default)(this, (SearchDrawer.__proto__ || (0, 
            _getPrototypeOf2.default)(SearchDrawer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(SearchDrawer, _PureComponent), (0, _createClass3.default)(SearchDrawer, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, backIcon = _props.backIcon, header = _props.header, isOpen = _props.isOpen, isFullWidth = _props.isFullWidth, onBackButton = _props.onBackButton, primaryIcon = _props.primaryIcon;
                return _react2.default.createElement(_Drawer2.default, {
                    backIcon: backIcon,
                    header: header,
                    isOpen: isOpen,
                    width: isFullWidth ? "full" : "wide",
                    onBackButton: onBackButton,
                    primaryIcon: primaryIcon,
                    backIconOffset: _sharedVariables.searchIconOffset
                }, _react2.default.createElement(ContentArea, {
                    isFullWidth: isFullWidth
                }, children));
            }
        } ]), SearchDrawer;
    }(_react.PureComponent);
    SearchDrawer.propTypes = {
        backIcon: _react.PropTypes.node,
        children: _react.PropTypes.node,
        header: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        isFullWidth: _react.PropTypes.bool,
        onBackButton: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node
    }, exports.default = SearchDrawer;
}, /* 86 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(24), _classnames2 = _interopRequireDefault(_classnames), _DrawerItem = __webpack_require__(87), _DefaultLinkComponent = __webpack_require__(37), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _NavigationItem = __webpack_require__(60), _NavigationItem2 = _interopRequireDefault(_NavigationItem), DrawerItem = function(_PureComponent) {
        function DrawerItem() {
            return (0, _classCallCheck3.default)(this, DrawerItem), (0, _possibleConstructorReturn3.default)(this, (DrawerItem.__proto__ || (0, 
            _getPrototypeOf2.default)(DrawerItem)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DrawerItem, _PureComponent), (0, _createClass3.default)(DrawerItem, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_DrawerItem.drawerItem)
                }, _react2.default.createElement(_NavigationItem2.default, {
                    action: this.props.action,
                    href: this.props.href,
                    icon: this.props.icon,
                    isCompact: this.props.isCompact,
                    linkComponent: this.props.linkComponent,
                    onClick: this.props.onClick,
                    subText: this.props.subText,
                    text: this.props.text,
                    textAfter: this.props.textAfter
                }));
            }
        } ]), DrawerItem;
    }(_react.PureComponent);
    DrawerItem.propTypes = {
        action: _react.PropTypes.node,
        href: _react.PropTypes.string,
        icon: _react.PropTypes.node,
        isCompact: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onClick: _react.PropTypes.func,
        subText: _react.PropTypes.string,
        text: _react.PropTypes.node,
        textAfter: _react.PropTypes.node
    }, DrawerItem.defaultProps = {
        isCompact: !1,
        isSelected: !1,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = DrawerItem;
}, /* 87 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(88);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 88 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, "._3Z5YZbrHdTHY6YqUrI1yqw{color:#42526e;border-radius:3px}._3Z5YZbrHdTHY6YqUrI1yqw:hover{background:rgba(9,30,66,.04)}._3Z5YZbrHdTHY6YqUrI1yqw:active{background:#deebff;color:#0052cc}", "" ]), 
    // exports
    exports.locals = {
        drawerItem: "_3Z5YZbrHdTHY6YqUrI1yqw",
        drawerItem: "_3Z5YZbrHdTHY6YqUrI1yqw"
    };
}, /* 89 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(12), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(13), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(14), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(15), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(16), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(17), _react2 = _interopRequireDefault(_react), _Search = __webpack_require__(90), _Search2 = _interopRequireDefault(_Search), Search = function(_PureComponent) {
        function Search() {
            return (0, _classCallCheck3.default)(this, Search), (0, _possibleConstructorReturn3.default)(this, (Search.__proto__ || (0, 
            _getPrototypeOf2.default)(Search)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Search, _PureComponent), (0, _createClass3.default)(Search, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, value = _props.value, onChange = _props.onChange, placeholder = _props.placeholder;
                return _react2.default.createElement("div", {
                    className: _Search2.default.search
                }, _react2.default.createElement("div", {
                    className: _Search2.default.searchBox
                }, _react2.default.createElement("input", {
                    autoFocus: !0,
                    className: _Search2.default.input,
                    onChange: onChange,
                    placeholder: placeholder,
                    type: "text",
                    value: value
                }), _react2.default.createElement("div", {
                    className: _Search2.default.clearButtonOuter
                }, _react2.default.createElement("button", {
                    className: _Search2.default.clearButton,
                    onClick: this.props.onSearchClear,
                    onMouseDown: function(e) {
                        return e.preventDefault();
                    }
                }, this.props.clearIcon))), _react2.default.createElement("div", {
                    className: _Search2.default.results
                }, children));
            }
        } ]), Search;
    }(_react.PureComponent);
    Search.propTypes = {
        placeholder: _react.PropTypes.string,
        clearIcon: _react.PropTypes.node,
        children: _react.PropTypes.node,
        onChange: _react.PropTypes.func.isRequired,
        onSearchClear: _react.PropTypes.func,
        value: _react.PropTypes.string
    }, Search.defaultProps = {
        placeholder: "Search"
    }, exports.default = Search;
}, /* 90 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(91);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(21)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 91 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(20)(), // imports
    // module
    exports.push([ module.id, ".CyFQIKhI_cFdIUqVlSh91{padding:4px 0 0 24px}._2ZRe8sLujz33RqbuH26jTJ{display:-webkit-box;display:flex;color:#172b4d}._3ZLdHH53nhRgs8ff2Bc4XY{border:0;color:inherit;-webkit-box-flex:1;flex-grow:1;font-size:1.4em;outline:0}._2ODF3w6SBy2lQLVbtv4EVr{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;margin-right:16px}._1MBdFBWJZ6OoU4jOtVuL3t{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;margin:0;background:none;border:none;border-radius:50%;padding:0;width:32px;height:32px;outline:none;color:inherit}._1MBdFBWJZ6OoU4jOtVuL3t:focus{outline:none;box-shadow:0 0 0 2px #4c9aff}._1MBdFBWJZ6OoU4jOtVuL3t:hover{background:rgba(9,30,66,.04)}._1MBdFBWJZ6OoU4jOtVuL3t:active{background:#deebff;color:#0052cc}._157s8EkNkQNIA3k6K-b3La{margin-top:24px}", "" ]), 
    // exports
    exports.locals = {
        search: "CyFQIKhI_cFdIUqVlSh91",
        search: "CyFQIKhI_cFdIUqVlSh91",
        searchBox: "_2ZRe8sLujz33RqbuH26jTJ",
        searchBox: "_2ZRe8sLujz33RqbuH26jTJ",
        input: "_3ZLdHH53nhRgs8ff2Bc4XY",
        input: "_3ZLdHH53nhRgs8ff2Bc4XY",
        clearButtonOuter: "_2ODF3w6SBy2lQLVbtv4EVr",
        clearButtonOuter: "_2ODF3w6SBy2lQLVbtv4EVr",
        clearButton: "_1MBdFBWJZ6OoU4jOtVuL3t",
        clearButton: "_1MBdFBWJZ6OoU4jOtVuL3t",
        results: "_157s8EkNkQNIA3k6K-b3La",
        results: "_157s8EkNkQNIA3k6K-b3La"
    };
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/navigation/dist/bundle-cjs.js
// module id = 360
// module chunks = 0